import React, { Component } from "react";
// import Select from "react-select";
import Swal from "sweetalert2";
import firebase, { storage } from "../Firebase";
import DocumentOcrUpload from "./DocumentOcrUpload";
import FormStepNav from "./FormStepNav";
import { getValidateByOcrFieldName } from "../utils/ocrApi";
import { isNonstaffStatus } from "../utils/form1Completeness";
import { resolveEmployeeDoc } from "../utils/employeeIdentity";

class Form2 extends Component {
  constructor() {
    super();
    this.ref = firebase.firestore().collection("employees");

    this.state = {
      nik: "",
      nama_lengkap: "",
      tanggal_lahir: "",
      status_karyawan: "",

      foto_rekening_bank: "",
      foto_rekening_bank_status: "",
      foto_rekening_bank_label: null,
      rekeningBankFile: null,
      rekeningBankUrl: null,
      rekening_bank_url: "",

      foto_mutasi_rekening: "",
      foto_mutasi_rekening_status: "",
      foto_mutasi_rekening_label: null,
      mutasiRekeningFile: null,
      mutasiRekeningUrl: null,
      mutasi_rekening_url: "",

      //state selected rekening
      selected_bank: "",
      rekening_error: "",
      nomor_rekening_bank: "",
      trial: false,

      // ✅ State upload files dan status
      foto_ijasah_status: "",
      ijasahFile: null,
      ijasahUrl: null,
      foto_ijasah_label: null,
      ijasah_url: "",

      foto_transkrip_status: "",
      transkripFile: null,
      transkripUrl: null,
      foto_transkrip_label: null,
      transkrip_url: "",

      foto_skck_status: "",
      skckFile: null,
      skckUrl: null,
      foto_skck_label: null,
      skck_url: "",

      foto_bpjs_kesehatan_status: "",
      foto_bpjs_kesehatan_label: null,
      bpjsKesehatanFile: null,
      bpjsKesehatanUrl: null,
      bpjs_kesehatan_url: "",

      foto_bpjs_ketenagakerjaan_status: "",
      foto_bpjs_ketenagakerjaan_label: null,
      bpjsKetenagaKerjaanFile: null,
      bpjsKetenagakerjaanUrl: null,
      bpjs_ketenagakerjaan_url: "",

      foto_keterangan_kesehatan_status: "",
      foto_keterangan_kesehatan_label: null,
      keteranganKesehatanFile: null,
      keteranganKesehatanUrl: null,
      keterangan_kesehatan_url: "",

      foto_surat_pernyataan_kesanggupan_bpjs_status: "",
      foto_surat_pernyataan_kesanggupan_bpjs_label: null,
      suratPernyataanKesanggupanBPJSFile: null,
      suratPernyataanKesanggupanBPJSUrl: null,
      surat_pernyataan_kesanggupan_bpjs_url: "",

      foto_keterangan_bpjs_tidak_aktif_status: "",
      foto_keterangan_bpjs_tidak_aktif_label: null,
      keteranganBPJSTidakAktifFile: null,
      keteranganBPJSTidakAktifUrl: null,
      keterangan_bpjs_tidak_aktif_url: "",

      foto_peserta_jkn_status: "",
      foto_peserta_jkn_label: null,
      pesertaJKNFile: null,
      pesertaJKNUrl: null,
      peserta_jkn_url: "",

      foto_iuran_jkn_status: "",
      foto_iuran_jkn_label: null,
      iuranJKNFile: null,
      iuranJKNUrl: null,
      iuran_jkn_url: "",

      // State vaksinasi files
      foto_vaksinasi_1_status: "",
      foto_vaksinasi_1_label: null,
      vaksinasi1File: null,
      vaksinasi1Url: null,
      vaksinasi_1_url: "",

      foto_vaksinasi_2_status: "",
      foto_vaksinasi_2_label: null,
      vaksinasi2File: null,
      vaksinasi2Url: null,
      vaksinasi_2_url: "",

      foto_vaksinasi_3_status: "",
      foto_vaksinasi_3_label: null,
      vaksinasi3File: null,
      vaksinasi3Url: null,
      vaksinasi_3_url: "",

      foto_pemadanan_npwp_status: "",
      foto_pemadanan_npwp_label: null,
      pemadananNPWPFile: null,
      pemadananNPWPUrl: null,
      pemadanan_npwp_url: "",

      foto_surat_lamaran_status: "",
      foto_surat_lamaran_label: null,
      suratLamaranFile: null,
      suratLamaranUrl: null,
      surat_lamaran_url: "",

      foto_formulir_lamaran_pekerjaan_status: "",
      foto_formulir_lamaran_pekerjaan_label: null,
      formulirLamaranPekerjaanFile: null,
      formulirLamaranPekerjaanUrl: null,
      formulir_lamaran_pekerjaan_url: "",

      foto_formulir_okb_status: "",
      foto_formulir_okb_label: null,
      formulirOKBFile: null,
      formulirOKBUrl: null,
      formulir_okb_url: "",

      // ✅ State form data
      tanggal_berlaku_skck: "",
      bpjs_status: "active",
      keterangan_kartu_bpjs_ketenagakerjaan: "Belum Dapat",
      tanggal_pembuatan_surat_keterangan_sehat: "",
      status_iuran: "",

      // ✅ State utilitas
      isFormValid: false,
      tanggal_masuk: this.currentDate(),
      agreement: false,
      submiting: false,
    };

    this.autosaveTimer = null;
    this.pendingAutosave = {};
    this.flushAutosaveOnLeave = () => {
      this.flushAutosave();
    };
  }

  componentDidMount() {
    this.cekLogin();
    window.addEventListener("beforeunload", this.flushAutosaveOnLeave);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.flushAutosaveOnLeave);
    this.flushAutosave();
    if (this._submitValidityTimer) {
      clearTimeout(this._submitValidityTimer);
      this._submitValidityTimer = null;
    }
  }

  componentDidUpdate() {
    if (this.state.submiting) {
      return;
    }
    if (this._submitValidityTimer) {
      clearTimeout(this._submitValidityTimer);
    }
    this._submitValidityTimer = setTimeout(() => {
      this._submitValidityTimer = null;
      this.updateSubmitButtonStatus();
    }, 100);
  }

  cekLogin = async () => {
    const id = localStorage.getItem("id");
    if (id == null) {
      // Ini sudah login, masuk ke form
      this.props.history.push("/");
    } else {
      const lStorage = JSON.parse(id);
      const nik = lStorage[0].nik;
      const status_karyawan = lStorage[0].status_karyawan?.toLowerCase();
      const tanggal_lahir_raw = lStorage[0].tanggal_lahir;

      let bank = "";
      if (status_karyawan === "staff") {
        bank = "mas";
      } else if (isNonstaffStatus(status_karyawan)) {
        bank = "";
      }

      const formatTanggalLahir = (rawDate) => {
        if (!rawDate || rawDate.length !== 8) {
          console.log("❌ Format tanggal lahir tidak valid:", rawDate);
          return "";
        }

        try {
          const day = rawDate.substring(0, 2);
          const month = rawDate.substring(2, 4);
          const year = rawDate.substring(4, 8);

          if (parseInt(day) < 1 || parseInt(day) > 31) {
            console.log("❌ Hari tidak valid:", day);
            return "";
          }
          if (parseInt(month) < 1 || parseInt(month) > 12) {
            console.log("❌ Bulan tidak valid:", month);
            return "";
          }
          if (
            parseInt(year) < 1900 ||
            parseInt(year) > new Date().getFullYear()
          ) {
            console.log("❌ Tahun tidak valid:", year);
            return "";
          }

          const formattedDate = `${year}-${month}-${day}`;
          console.log(
            "✅ Tanggal lahir diformat:",
            `${rawDate} → ${formattedDate}`
          );

          return formattedDate;
        } catch (error) {
          console.error("❌ Error formatting tanggal lahir:", error);
          return "";
        }
      };

      const tanggal_lahir_formatted = formatTanggalLahir(tanggal_lahir_raw);

      try {
        const snapshot = await this.ref
          .where("nik", "==", nik)
          .where("tanggal_lahir", "==", tanggal_lahir_raw)
          .get();

        let existingData = {};
        if (!snapshot.empty) {
          const doc = snapshot.docs[0];
          existingData = doc.data();
          console.log("✅ Data existing employee ditemukan");

          // ✅ Load data rekening MCU
          const rekeningMCU =
            existingData.nomor_rekening_bank_mcu ||
            existingData.nomor_rekening_mandiri_mcu ||
            existingData.nomor_rekening_mas_mcu ||
            existingData.nomor_rekening_bank ||
            "";

          const existingBank = existingData.selected_bank || "";

          let selectedBankForState = existingBank;
          if (
            isNonstaffStatus(status_karyawan) &&
            bank === "" &&
            rekeningMCU &&
            rekeningMCU.toString().trim() !== ""
          ) {
            const rekeningLength = rekeningMCU.toString().length;
            if (rekeningLength === 10) {
              selectedBankForState = "mas";
            } else if (rekeningLength === 13) {
              selectedBankForState = "mandiri";
            }
            if (selectedBankForState && selectedBankForState !== existingBank) {
              console.log(
                `🤖 Auto-detected bank: ${selectedBankForState} based on MCU rekening length`
              );
            }
          }

          console.log("🏦 Bank selection logic:", {
            status_karyawan,
            existingBank,
            finalBank: selectedBankForState,
            rekeningMCU,
          });

          this.setState(
            {
              nik: nik,
              tanggal_lahir: tanggal_lahir_raw,
              nama_lengkap: existingData.nama_lengkap || "",
              tanggal_lahir_formatted: tanggal_lahir_formatted,
              status_karyawan: status_karyawan,
              selected_bank: selectedBankForState,
              nomor_rekening_bank_mcu: String(rekeningMCU),
              nomor_rekening_bank: String(rekeningMCU), // ✅ Pre-fill jika ada data MCU
              rekening_bank_url: existingData.rekening_bank_url || "",
              trial: existingData.trial === true,
              keterangan_kartu_bpjs_ketenagakerjaan:
                existingData.keterangan_kartu_bpjs_ketenagakerjaan ||
                "Belum Dapat",
            },
            () => {
              this.getPreviousData();
              // Setelah batch React: sinkronkan tombol submit (getPreviousData async)
              setTimeout(() => this.updateSubmitButtonStatus(), 0);
            }
          );
        } else {
          this.setState({
            nik: nik,
            tanggal_lahir: tanggal_lahir_raw,
            tanggal_lahir_formatted: tanggal_lahir_formatted,
            status_karyawan: status_karyawan,
            // selected_bank: bank,
            // nomor_rekening_bank_mcu: "",
            // nomor_rekening_bank: "",
          });
        }
      } catch (error) {
        console.error("❌ Error loading existing data:", error);
        this.setState({
          nik: nik,
          tanggal_lahir: tanggal_lahir_raw,
          tanggal_lahir_formatted: tanggal_lahir_formatted,
          status_karyawan: status_karyawan,
          // selected_bank: bank,
          // nomor_rekening_bank_mcu: "",
          // nomor_rekening_bank: "",
        });
      }
    }
  };

  getPreviousData = async () => {
    try {
      const { nik, tanggal_lahir } = this.state;

      if (!nik || !tanggal_lahir) {
        console.log("⚠️ NIK atau tanggal lahir belum tersedia");
        return;
      }

      console.log("🔍 Fetching previous data for NIK:", nik);

      const snapshot = await this.ref
        .where("nik", "==", nik)
        .where("tanggal_lahir", "==", tanggal_lahir)
        .get();

      if (!snapshot.empty) {
        const doc = snapshot.docs[0];
        const existingData = doc.data();
        console.log("✅ Previous data found:", existingData);

        // ✅ Mapping data dari Firestore ke state
        this.setState({
          // Rekening Bank
          selected_bank:
            existingData.selected_bank || this.state.selected_bank || "",
          nomor_rekening_bank:
            existingData.nomor_rekening_bank ||
            this.state.nomor_rekening_bank ||
            "",
          rekening_bank_url: existingData.rekening_bank_url || "",
          mutasi_rekening_url: existingData.mutasi_rekening_url || "",
          trial: existingData.trial === true,

          // Ijasah & Transkrip
          ijasah_url: existingData.ijasah_url || "",
          transkrip_url: existingData.transkrip_url || "",

          // SKCK
          skck_url: existingData.skck_url || "",
          tanggal_berlaku_skck: existingData.tanggal_berlaku_skck || "",

          // BPJS
          bpjs_kesehatan_url: existingData.bpjs_kesehatan_url || "",
          bpjs_ketenagakerjaan_url: existingData.bpjs_ketenagakerjaan_url || "",
          keterangan_kesehatan_url: existingData.keterangan_kesehatan_url || "",
          bpjs_status: existingData.bpjs_status || "active",
          keterangan_kartu_bpjs_ketenagakerjaan:
            existingData.keterangan_kartu_bpjs_ketenagakerjaan || "Belum Dapat",
          tanggal_pembuatan_surat_keterangan_sehat:
            existingData.tanggal_pembuatan_surat_keterangan_sehat || "",

          // BPJS Tidak Aktif
          surat_pernyataan_kesanggupan_bpjs_url:
            existingData.surat_pernyataan_kesanggupan_bpjs_url || "",
          keterangan_bpjs_tidak_aktif_url:
            existingData.keterangan_bpjs_tidak_aktif_url || "",

          // JKN
          peserta_jkn_url: existingData.peserta_jkn_url || "",
          iuran_jkn_url: existingData.iuran_jkn_url || "",
          status_iuran: existingData.status_iuran || "",

          // Vaksinasi
          vaksinasi_1_url: existingData.vaksinasi_1_url || "",
          vaksinasi_2_url: existingData.vaksinasi_2_url || "",
          vaksinasi_3_url: existingData.vaksinasi_3_url || "",

          // NPWP & Lamaran
          pemadanan_npwp_url: existingData.pemadanan_npwp_url || "",
          surat_lamaran_url: existingData.surat_lamaran_url || "",
          formulir_lamaran_pekerjaan_url:
            existingData.formulir_lamaran_pekerjaan_url || "",
          formulir_okb_url: existingData.formulir_okb_url || "",

          // ✅ Update status upload jika URL sudah ada
          foto_rekening_bank_status: existingData.rekening_bank_url
            ? "Upload selesai"
            : "",
          foto_mutasi_rekening_status: existingData.mutasi_rekening_url
            ? "Upload selesai"
            : "",
          foto_ijasah_status: existingData.ijasah_url ? "Upload selesai" : "",
          foto_transkrip_status: existingData.transkrip_url
            ? "Upload selesai"
            : "",
          foto_skck_status: existingData.skck_url ? "Upload selesai" : "",
          foto_bpjs_kesehatan_status: existingData.bpjs_kesehatan_url
            ? "Upload selesai"
            : "",
          foto_bpjs_ketenagakerjaan_status:
            existingData.bpjs_ketenagakerjaan_url ? "Upload selesai" : "",
          foto_keterangan_kesehatan_status:
            existingData.keterangan_kesehatan_url ? "Upload selesai" : "",
          foto_surat_pernyataan_kesanggupan_bpjs_status:
            existingData.surat_pernyataan_kesanggupan_bpjs_url
              ? "Upload selesai"
              : "",
          foto_keterangan_bpjs_tidak_aktif_status:
            existingData.keterangan_bpjs_tidak_aktif_url
              ? "Upload selesai"
              : "",
          foto_peserta_jkn_status: existingData.peserta_jkn_url
            ? "Upload selesai"
            : "",
          foto_iuran_jkn_status: existingData.iuran_jkn_url
            ? "Upload selesai"
            : "",
          foto_vaksinasi_1_status: existingData.vaksinasi_1_url
            ? "Upload selesai"
            : "",
          foto_vaksinasi_2_status: existingData.vaksinasi_2_url
            ? "Upload selesai"
            : "",
          foto_vaksinasi_3_status: existingData.vaksinasi_3_url
            ? "Upload selesai"
            : "",
          foto_pemadanan_npwp_status: existingData.pemadanan_npwp_url
            ? "Upload selesai"
            : "",
          foto_surat_lamaran_status: existingData.surat_lamaran_url
            ? "Upload selesai"
            : "",
          foto_formulir_lamaran_pekerjaan_status:
            existingData.formulir_lamaran_pekerjaan_url ? "Upload selesai" : "",
          foto_formulir_okb_status: existingData.formulir_okb_url
            ? "Upload selesai"
            : "",

          // ✅ Set preview URL jika ada
          rekeningBankUrl: existingData.rekening_bank_url || null,
          mutasiRekeningUrl: existingData.mutasi_rekening_url || null,
          ijasahUrl: existingData.ijasah_url || null,
          transkripUrl: existingData.transkrip_url || null,
          skckUrl: existingData.skck_url || null,
          bpjsKesehatanUrl: existingData.bpjs_kesehatan_url || null,
          bpjsKetenagakerjaanUrl: existingData.bpjs_ketenagakerjaan_url || null,
          keteranganKesehatanUrl: existingData.keterangan_kesehatan_url || null,
          suratPernyataanKesanggupanBPJSUrl:
            existingData.surat_pernyataan_kesanggupan_bpjs_url || null,
          keteranganBPJSTidakAktifUrl:
            existingData.keterangan_bpjs_tidak_aktif_url || null,
          pesertaJKNUrl: existingData.peserta_jkn_url || null,
          iuranJKNUrl: existingData.iuran_jkn_url || null,
          vaksinasi1Url: existingData.vaksinasi_1_url || null,
          vaksinasi2Url: existingData.vaksinasi_2_url || null,
          vaksinasi3Url: existingData.vaksinasi_3_url || null,
          pemadananNPWPUrl: existingData.pemadanan_npwp_url || null,
          suratLamaranUrl: existingData.surat_lamaran_url || null,
          formulirLamaranPekerjaanUrl:
            existingData.formulir_lamaran_pekerjaan_url || null,
          formulirOKBUrl: existingData.formulir_okb_url || null,
        }, () => {
          // ✅ Update submit button status setelah data di-load
          console.log("✅ Previous data loaded successfully");
          console.log("📋 Form data fields loaded:", {
            tanggal_berlaku_skck: this.state.tanggal_berlaku_skck,
            status_iuran: this.state.status_iuran,
            tanggal_pembuatan_surat_keterangan_sehat: this.state.tanggal_pembuatan_surat_keterangan_sehat,
            bpjs_status: this.state.bpjs_status,
          });
          
          // ✅ Update submit button status setelah semua data ter-load
          setTimeout(() => {
            this.updateSubmitButtonStatus();
          }, 100);
        });
      } else {
        console.log("ℹ️ No previous data found");
      }
    } catch (error) {
      console.error("❌ Error fetching previous data:", error);
    }
  };

  addQueue = async (docType) => {
    const checkQueueRef = firebase.firestore().collection("check_queue");
    const employeesRef = firebase.firestore().collection("employees");

    const querySnapshot = await employeesRef
      .where("nik", "==", this.state.nik)
      .get();

    const employeeDoc = querySnapshot.docs[0];
    let nama = employeeDoc.data().nama_lengkap;

    checkQueueRef.add({
      nama: nama,
      nik: this.state.nik,
      type: docType,
      url: this.state[docType + "_url"],
    });

    console.log(`✅ Added to check queue: ${docType}`);
  };

  selectFotoRekening = (e) => {
    // ✅ TAMBAH: Cek apakah ada file yang dipilih
    if (!e.target.files || e.target.files.length === 0) {
      console.log("❌ No file selected");
      return;
    }

    const file = e.target.files[0];

    // ✅ TAMBAH: Double check file ada
    if (!file) {
      console.log("❌ File is undefined");
      return;
    }

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_rekening_bank_status: "File harus berupa gambar",
      });
      return;
    }

    // ✅ TAMBAH: Validasi ukuran file
    if (!file.size) {
      alert("❌ File tidak valid atau rusak");
      e.target.value = "";
      this.setState({
        foto_rekening_bank_status: "File tidak valid",
      });
      return;
    }

    // Batasi ukuran file hanya 3 MB
    var FileSize = file.size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_rekening_bank_status: "Melebihi ukuran maksimal",
      });
      return;
    }

    // ✅ Lanjutkan dengan proses upload jika semua validasi lolos
    this.setState({
      rekeningBankFile: file,
      foto_rekening_bank_label: file.name,
      foto_rekening_bank_status: "Uploading...",
    });

    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      this.setState({
        rekeningBankFile: file,
        rekeningBankUrl: fileReader.result,
      });
    };

    if (file) {
      fileReader.readAsDataURL(file);
    }

    const file_name = Date.now() + "-" + file.name;
    const folder_name =
      this.state.tanggal_masuk.split("-")[0] +
      this.state.tanggal_masuk.split("-")[1];
    const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        console.log("📸 Upload progress rekening:", progress + "%");
        this.setState({
          foto_rekening_bank_status: `Uploading... ${progress}%`,
        });
      },
      (error) => {
        console.log("❌ Upload error rekening:", error);
        this.setState({
          foto_rekening_bank_status: "Upload gagal",
        });
      },
      () => {
        storage
          .ref(`${folder_name}`)
          .child(file_name)
          .getDownloadURL()
          .then((url) => {
            console.log("✅ Rekening URL:", url);
            this.setState({
              rekening_bank_url: url,
              foto_rekening_bank_status: "Upload selesai",
            });
            this.updateFileUrl("rekening_bank");
            this.updateSubmitButtonStatus();
          })
          .catch((error) => {
            console.error("❌ Error getting rekening download URL:", error);
            this.setState({
              foto_rekening_bank_status: "Upload gagal",
            });
          });
      }
    );
  };

  selectFotoMutasiRekening = (e) => {
    // ✅ TAMBAH: Cek apakah ada file yang dipilih
    if (!e.target.files || e.target.files.length === 0) {
      console.log("❌ No file selected");
      return;
    }

    const file = e.target.files[0];

    // ✅ TAMBAH: Double check file ada
    if (!file) {
      console.log("❌ File is undefined");
      return;
    }

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_mutasi_rekening_status: "File harus berupa gambar",
      });
      return;
    }

    // ✅ TAMBAH: Validasi ukuran file
    if (!file.size) {
      alert("❌ File tidak valid atau rusak");
      e.target.value = "";
      this.setState({
        foto_mutasi_rekening_status: "File tidak valid",
      });
      return;
    }

    // Batasi ukuran file hanya 3 MB
    var FileSize = file.size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_mutasi_rekening_status: "Melebihi ukuran maksimal",
      });
      return;
    }

    // ✅ Lanjutkan dengan proses upload jika semua validasi lolos
    this.setState({
      mutasiRekeningFile: file,
      foto_mutasi_rekening_label: file.name,
      foto_mutasi_rekening_status: "Uploading...",
    });

    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      this.setState({
        mutasiRekeningFile: file,
        mutasiRekeningUrl: fileReader.result,
      });
    };

    if (file) {
      fileReader.readAsDataURL(file);
    }

    const file_name = Date.now() + "-" + file.name;
    const folder_name =
      this.state.tanggal_masuk.split("-")[0] +
      this.state.tanggal_masuk.split("-")[1];
    const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        console.log("📸 Upload progress mutasi rekening:", progress + "%");
        this.setState({
          foto_mutasi_rekening_status: `Uploading... ${progress}%`,
        });
      },
      (error) => {
        console.log("❌ Upload error mutasi rekening:", error);
        this.setState({
          foto_mutasi_rekening_status: "Upload gagal",
        });
      },
      () => {
        storage
          .ref(`${folder_name}`)
          .child(file_name)
          .getDownloadURL()
          .then((url) => {
            console.log("✅ Mutasi Rekening URL:", url);
            this.setState({
              mutasi_rekening_url: url,
              foto_mutasi_rekening_status: "Upload selesai",
            });
            this.updateFileUrl("mutasi_rekening");
            this.updateSubmitButtonStatus();
          })
          .catch((error) => {
            console.error(
              "❌ Error getting mutasi rekening download URL:",
              error
            );
            this.setState({
              foto_mutasi_rekening_status: "Upload gagal",
            });
          });
      }
    );
  };

  selectFotoIjasah = (e) => {
    const file = e.target.files[0];

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG, GIF) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_ijasah_status: "File harus berupa gambar",
      });
      return;
    }
    // Batasi ukuran file hanya 3 MB
    var FileSize = e.target.files[0].size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_ijasah_status: "Melebihi ukuran maksimal",
      });
    } else {
      this.setState({
        ijasahFile: e.target.files[0],
        foto_ijasah_label: e.target.files[0].name,
        foto_ijasah_status: "Uploading...",
      });
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        this.setState({ ijasahFile: file, ijasahUrl: fileReader.result });
      };
      if (file) {
        fileReader.readAsDataURL(file);
      }

      const file_name = Date.now() + "-" + file.name;
      const folder_name =
        this.state.tanggal_masuk.split("-")[0] +
        this.state.tanggal_masuk.split("-")[1];
      const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log(progress);
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref(`${folder_name}`)
            .child(file_name)
            .getDownloadURL()
            .then((url) => {
              console.log("URL " + url);
              this.setState({
                ijasah_url: url,
                foto_ijasah_status: "Upload selesai",
              });
              // Update validation status
              this.updateFileUrl("ijasah");
              this.updateSubmitButtonStatus();
            });
        }
      );
    }
  };

  selectFotoTranskrip = (e) => {
    const file = e.target.files[0];

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG, GIF) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_transkrip_status: "File harus berupa gambar",
      });
      return;
    }
    // Batasi ukuran file hanya 3 MB
    var FileSize = e.target.files[0].size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_transkrip_status: "Melebihi ukuran maksimal",
      });
    } else {
      this.setState({
        transkripFile: e.target.files[0],
        foto_transkrip_label: e.target.files[0].name,
        foto_transkrip_status: "Uploading...",
      });
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        this.setState({ transkripFile: file, transkripUrl: fileReader.result });
      };
      if (file) {
        fileReader.readAsDataURL(file);
      }

      const file_name = Date.now() + "-" + file.name;
      const folder_name =
        this.state.tanggal_masuk.split("-")[0] +
        this.state.tanggal_masuk.split("-")[1];
      const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log(progress);
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref(`${folder_name}`)
            .child(file_name)
            .getDownloadURL()
            .then((url) => {
              console.log("URL " + url);
              this.setState({
                transkrip_url: url,
                foto_transkrip_status: "Upload selesai",
              });
              this.updateFileUrl("transkrip");
              // Update validation status
              this.updateSubmitButtonStatus();
            });
        }
      );
    }
  };

  selectFotoSKCK = (e) => {
    const file = e.target.files[0];

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG, GIF) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_skck_status: "File harus berupa gambar",
      });
      return;
    }
    // Batasi ukuran file hanya 3 MB
    var FileSize = e.target.files[0].size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_skck_status: "Melebihi ukuran maksimal",
      });
    } else {
      this.setState({
        skckFile: e.target.files[0],
        foto_skck_label: e.target.files[0].name,
        foto_skck_status: "Uploading...",
      });
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        this.setState({ skckFile: file, skckUrl: fileReader.result });
      };
      if (file) {
        fileReader.readAsDataURL(file);
      }

      const file_name = Date.now() + "-" + file.name;
      const folder_name =
        this.state.tanggal_masuk.split("-")[0] +
        this.state.tanggal_masuk.split("-")[1];
      const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log(progress);
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref(`${folder_name}`)
            .child(file_name)
            .getDownloadURL()
            .then((url) => {
              console.log("URL " + url);
              this.setState({
                skck_url: url,
                foto_skck_status: "Upload selesai",
              });
              this.updateFileUrl("skck");
              this.updateSubmitButtonStatus();
            });
        }
      );
    }
  };

  selectFotoBPJSKesehatan = (e) => {
    const file = e.target.files[0];

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG, GIF) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_bpjs_kesehatan_status: "File harus berupa gambar",
      });
      return;
    }
    // Batasi ukuran file hanya 3 MB
    var FileSize = e.target.files[0].size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_bpjs_kesehatan_status: "Melebihi ukuran maksimal",
      });
    } else {
      this.setState({
        bpjsKesehatanFile: e.target.files[0],
        foto_bpjs_kesehatan_label: e.target.files[0].name,
        foto_bpjs_kesehatan_status: "Uploading...",
      });
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        this.setState({
          bpjsKesehatanFile: file,
          bpjsKesehatanUrl: fileReader.result,
        });
      };
      if (file) {
        fileReader.readAsDataURL(file);
      }

      const file_name = Date.now() + "-" + file.name;
      const folder_name =
        this.state.tanggal_masuk.split("-")[0] +
        this.state.tanggal_masuk.split("-")[1];
      const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log(progress);
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref(`${folder_name}`)
            .child(file_name)
            .getDownloadURL()
            .then((url) => {
              console.log("URL " + url);
              this.setState({
                bpjs_kesehatan_url: url,
                foto_bpjs_kesehatan_status: "Upload selesai",
              });
              this.updateFileUrl("bpjs_kesehatan");
              // Update validation status
              this.updateSubmitButtonStatus();
            });
        }
      );
    }
  };

  selectFotoBPJSKetenagakerjaan = (e) => {
    const file = e.target.files[0];

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG, GIF) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_bpjs_ketenagakerjaan_status: "File harus berupa gambar",
      });
      return;
    }
    // Batasi ukuran file hanya 3 MB
    var FileSize = e.target.files[0].size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_bpjs_ketenagakerjaan_status: "Melebihi ukuran maksimal",
      });
    } else {
      this.setState({
        bpjsKetenagaKerjaanFile: e.target.files[0],
        foto_bpjs_ketenagakerjaan_label: e.target.files[0].name,
        foto_bpjs_ketenagakerjaan_status: "Uploading...",
      });
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        this.setState({
          bpjsKetenagaKerjaanFile: file,
          bpjsKetenagakerjaanUrl: fileReader.result,
        });
      };
      if (file) {
        fileReader.readAsDataURL(file);
      }

      const file_name = Date.now() + "-" + file.name;
      const folder_name =
        this.state.tanggal_masuk.split("-")[0] +
        this.state.tanggal_masuk.split("-")[1];
      const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log(progress);
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref(`${folder_name}`)
            .child(file_name)
            .getDownloadURL()
            .then((url) => {
              console.log("URL " + url);
              this.setState({
                bpjs_ketenagakerjaan_url: url,
                foto_bpjs_ketenagakerjaan_status: "Upload selesai",
              });
              this.updateFileUrl("bpjs_ketenagakerjaan");
              // Update validation status
              this.updateSubmitButtonStatus();
            });
        }
      );
    }
  };

  selectFotoKeteranganKesehatan = (e) => {
    const file = e.target.files[0];

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG, GIF) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_keterangan_kesehatan_status: "File harus berupa gambar",
      });
      return;
    }
    // Batasi ukuran file hanya 3 MB
    var FileSize = e.target.files[0].size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_keterangan_kesehatan_status: "Melebihi ukuran maksimal",
      });
    } else {
      this.setState({
        keteranganKesehatanFile: e.target.files[0],
        foto_keterangan_kesehatan_label: e.target.files[0].name,
        foto_keterangan_kesehatan_status: "Uploading...",
      });
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        this.setState({
          keteranganKesehatanFile: file,
          keteranganKesehatanUrl: fileReader.result,
        });
      };
      if (file) {
        fileReader.readAsDataURL(file);
      }

      const file_name = Date.now() + "-" + file.name;
      const folder_name =
        this.state.tanggal_masuk.split("-")[0] +
        this.state.tanggal_masuk.split("-")[1];
      const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log(progress);
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref(`${folder_name}`)
            .child(file_name)
            .getDownloadURL()
            .then((url) => {
              console.log("URL " + url);
              this.setState({
                keterangan_kesehatan_url: url,
                foto_keterangan_kesehatan_status: "Upload selesai",
              });
              this.updateFileUrl("keterangan_kesehatan");
              // Update validation status
              this.updateSubmitButtonStatus();
            });
        }
      );
    }
  };

  selectFotoSuratPernyataanKesanggupanBPJS = (e) => {
    if (!e.target.files || e.target.files.length === 0) return;
    const file = e.target.files[0];

    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG) yang diperbolehkan!"
      );
      e.target.value = "";
      this.setState({
        foto_surat_pernyataan_kesanggupan_bpjs_status:
          "File harus berupa gambar",
      });
      return;
    }

    const size = file.size / 1024 / 1024;
    if (size > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MB");
      this.setState({
        foto_surat_pernyataan_kesanggupan_bpjs_status:
          "Melebihi ukuran maksimal",
      });
      return;
    }

    this.setState({
      suratPernyataanKesanggupanBPJSFile: file,
      foto_surat_pernyataan_kesanggupan_bpjs_label: file.name,
      foto_surat_pernyataan_kesanggupan_bpjs_status: "Uploading...",
    });

    const fr = new FileReader();
    fr.onloadend = () =>
      this.setState({ suratPernyataanKesanggupanBPJSUrl: fr.result });
    fr.readAsDataURL(file);

    const file_name = Date.now() + "-" + file.name;
    const folder_name =
      this.state.tanggal_masuk.split("-")[0] +
      this.state.tanggal_masuk.split("-")[1];
    const task = storage.ref(`${folder_name}/${file_name}`).put(file);

    task.on(
      "state_changed",
      (snap) => {
        const prog = Math.round(
          (snap.bytesTransferred / snap.totalBytes) * 100
        );
        this.setState({
          foto_surat_pernyataan_kesanggupan_bpjs_status: `Uploading... ${prog}%`,
        });
      },
      () =>
        this.setState({
          foto_surat_pernyataan_kesanggupan_bpjs_status: "Upload gagal",
        }),
      () => {
        storage
          .ref(`${folder_name}`)
          .child(file_name)
          .getDownloadURL()
          .then((url) => {
            this.setState(
              {
                surat_pernyataan_kesanggupan_bpjs_url: url,
                foto_surat_pernyataan_kesanggupan_bpjs_status: "Upload selesai",
              },
              () => {
                this.updateFileUrl("surat_pernyataan_kesanggupan_bpjs");
                this.updateSubmitButtonStatus();
              }
            );
          });
      }
    );
  };

  selectFotoKeteranganBPJSTidakAktif = (e) => {
    const file = e.target.files[0];

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG, GIF) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_keterangan_bpjs_tidak_aktif_status: "File harus berupa gambar",
      });
      return;
    }
    // Batasi ukuran file hanya 3 MB
    var FileSize = e.target.files[0].size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_keterangan_bpjs_tidak_aktif_status: "Melebihi ukuran maksimal",
      });
    } else {
      this.setState({
        keteranganBPJSTidakAktifFile: e.target.files[0],
        foto_keterangan_bpjs_tidak_aktif_label: e.target.files[0].name,
        foto_keterangan_bpjs_tidak_aktif_status: "Uploading...",
      });
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        this.setState({
          keteranganBPJSTidakAktifFile: file,
          keteranganBPJSTidakAktifUrl: fileReader.result,
        });
      };
      if (file) {
        fileReader.readAsDataURL(file);
      }

      const file_name = Date.now() + "-" + file.name;
      const folder_name =
        this.state.tanggal_masuk.split("-")[0] +
        this.state.tanggal_masuk.split("-")[1];
      const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log(progress);
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref(`${folder_name}`)
            .child(file_name)
            .getDownloadURL()
            .then((url) => {
              console.log("URL " + url);
              this.setState({
                foto_keterangan_bpjs_tidak_aktif_status: "Upload selesai",
              });
              this.updateFileUrl("keterangan_bpjs_tidak_aktif");
              // Update validation status
              this.updateSubmitButtonStatus();
            });
        }
      );
    }
  };

  selectFotoPesertaJKN = (e) => {
    const file = e.target.files[0];

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG, GIF) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_peserta_jkn_status: "File harus berupa gambar",
      });
      return;
    }
    // Batasi ukuran file hanya 3 MB
    var FileSize = e.target.files[0].size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_peserta_jkn_status: "Melebihi ukuran maksimal",
      });
    } else {
      this.setState({
        pesertaJKNFile: e.target.files[0],
        foto_peserta_jkn_label: e.target.files[0].name,
        foto_peserta_jkn_status: "Uploading...",
      });
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        this.setState({
          pesertaJKNFile: file,
          pesertaJKNUrl: fileReader.result,
        });
      };
      if (file) {
        fileReader.readAsDataURL(file);
      }

      const file_name = Date.now() + "-" + file.name;
      const folder_name =
        this.state.tanggal_masuk.split("-")[0] +
        this.state.tanggal_masuk.split("-")[1];
      const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log(progress);
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref(`${folder_name}`)
            .child(file_name)
            .getDownloadURL()
            .then((url) => {
              console.log("URL " + url);
              this.setState({
                peserta_jkn_url: url,
                foto_peserta_jkn_status: "Upload selesai",
              });
              this.updateFileUrl("peserta_jkn");
              // Update validation status
              this.updateSubmitButtonStatus();
            });
        }
      );
    }
  };

  selectFotoIuranJKN = (e) => {
    const file = e.target.files[0];

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG, GIF) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_iuran_jkn_status: "File harus berupa gambar",
      });
      return;
    }
    // Batasi ukuran file hanya 3 MB
    var FileSize = e.target.files[0].size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_iuran_jkn_status: "Melebihi ukuran maksimal",
      });
    } else {
      this.setState({
        iuranJKNFile: e.target.files[0],
        foto_iuran_jkn_label: e.target.files[0].name,
        foto_iuran_jkn_status: "Uploading...",
      });
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        this.setState({ iuranJKNFile: file, iuranJKNUrl: fileReader.result });
      };
      if (file) {
        fileReader.readAsDataURL(file);
      }

      const file_name = Date.now() + "-" + file.name;
      const folder_name =
        this.state.tanggal_masuk.split("-")[0] +
        this.state.tanggal_masuk.split("-")[1];
      const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log(progress);
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref(`${folder_name}`)
            .child(file_name)
            .getDownloadURL()
            .then((url) => {
              console.log("URL " + url);
              this.setState({
                iuran_jkn_url: url,
                foto_iuran_jkn_status: "Upload selesai",
              });
              this.updateFileUrl("iuran_jkn");
              // Update validation status
              this.updateSubmitButtonStatus();
            });
        }
      );
    }
  };

  selectFotoVaksinasi1 = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      console.log("❌ No file selected");
      return;
    }

    const file = e.target.files[0];

    // ✅ TAMBAH: Double check file ada
    if (!file) {
      console.log("❌ File is undefined");
      return;
    }

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG, GIF) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_vaksinasi_1_status: "File harus berupa gambar",
      });
      return;
    }

    // ✅ TAMBAH: Validasi ukuran file
    if (!file.size) {
      alert("❌ File tidak valid atau rusak");
      e.target.value = "";
      this.setState({
        foto_vaksinasi_1_status: "File tidak valid",
      });
      return;
    }

    // Batasi ukuran file hanya 3 MB
    var FileSize = file.size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_vaksinasi_1_status: "Melebihi ukuran maksimal",
      });
      return; // ✅ TAMBAH: return untuk stop eksekusi
    }

    // ✅ Lanjutkan dengan proses upload jika semua validasi lolos
    this.setState({
      vaksinasi1File: file,
      foto_vaksinasi_1_label: file.name,
      foto_vaksinasi_1_status: "Uploading...",
    });

    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      this.setState({
        vaksinasi1File: file,
        vaksinasi1Url: fileReader.result,
      });
    };

    if (file) {
      fileReader.readAsDataURL(file);
    }

    const file_name = Date.now() + "-" + file.name;
    const folder_name =
      this.state.tanggal_masuk.split("-")[0] +
      this.state.tanggal_masuk.split("-")[1];
    const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        console.log(progress);
      },
      (error) => {
        console.log(error);
        this.setState({
          foto_vaksinasi_1_status: "Upload gagal",
        });
      },
      () => {
        storage
          .ref(`${folder_name}`)
          .child(file_name)
          .getDownloadURL()
          .then((url) => {
            console.log("URL " + url);
            this.setState({
              vaksinasi_1_url: url,
              foto_vaksinasi_1_status: "Upload selesai",
            });
            this.updateFileUrl("vaksinasi_1");
            // Update validation status
            this.updateSubmitButtonStatus();
          })
          .catch((error) => {
            console.error("Error getting download URL:", error);
            this.setState({
              foto_vaksinasi_1_status: "Upload gagal",
            });
          });
      }
    );
  };

  selectFotoVaksinasi2 = (e) => {
    const file = e.target.files[0];

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG, GIF) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_vaksinasi_2_status: "File harus berupa gambar",
      });
      return;
    }
    // Batasi ukuran file hanya 3 MB
    var FileSize = e.target.files[0].size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_vaksinasi_2_status: "Melebihi ukuran maksimal",
      });
    } else {
      this.setState({
        vaksinasi2File: e.target.files[0],
        foto_vaksinasi_2_label: e.target.files[0].name,
        foto_vaksinasi_2_status: "Uploading...",
      });
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        this.setState({
          vaksinasi2File: file,
          vaksinasi2Url: fileReader.result,
        });
      };
      if (file) {
        fileReader.readAsDataURL(file);
      }

      const file_name = Date.now() + "-" + file.name;
      const folder_name =
        this.state.tanggal_masuk.split("-")[0] +
        this.state.tanggal_masuk.split("-")[1];
      const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log(progress);
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref(`${folder_name}`)
            .child(file_name)
            .getDownloadURL()
            .then((url) => {
              console.log("URL " + url);
              this.setState({
                vaksinasi_2_url: url,
                foto_vaksinasi_2_status: "Upload selesai",
              });
              this.updateFileUrl("vaksinasi_2");
              // Update validation status
              this.updateSubmitButtonStatus();
            });
        }
      );
    }
  };

  selectFotoVaksinasi3 = (e) => {
    const file = e.target.files[0];

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG, GIF) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_vaksinasi_3_status: "File harus berupa gambar",
      });
      return;
    }
    // Batasi ukuran file hanya 3 MB
    var FileSize = e.target.files[0].size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_vaksinasi_3_status: "Melebihi ukuran maksimal",
      });
    } else {
      this.setState({
        vaksinasi3File: e.target.files[0],
        foto_vaksinasi_3_label: e.target.files[0].name,
        foto_vaksinasi_3_status: "Uploading...",
      });
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        this.setState({
          vaksinasi3File: file,
          vaksinasi3Url: fileReader.result,
        });
      };
      if (file) {
        fileReader.readAsDataURL(file);
      }

      const file_name = Date.now() + "-" + file.name;
      const folder_name =
        this.state.tanggal_masuk.split("-")[0] +
        this.state.tanggal_masuk.split("-")[1];
      const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log(progress);
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref(`${folder_name}`)
            .child(file_name)
            .getDownloadURL()
            .then((url) => {
              console.log("URL " + url);
              this.setState({
                vaksinasi_3_url: url,
                foto_vaksinasi_3_status: "Upload selesai",
              });
              this.updateFileUrl("vaksinasi_3");
              // Update validation status
              this.updateSubmitButtonStatus();
            });
        }
      );
    }
  };

  selectFotoPemadananNPWP = (e) => {
    const file = e.target.files[0];

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG, GIF) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_pemadanan_npwp_status: "File harus berupa gambar",
      });
      return;
    }
    // Batasi ukuran file hanya 3 MB
    var FileSize = e.target.files[0].size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_pemadanan_npwp_status: "Melebihi ukuran maksimal",
      });
    } else {
      this.setState({
        pemadananNPWPFile: e.target.files[0],
        foto_pemadanan_npwp_label: e.target.files[0].name,
        foto_pemadanan_npwp_status: "Uploading...",
      });
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        this.setState({
          pemadananNPWPFile: file,
          pemadananNPWPUrl: fileReader.result,
        });
      };
      if (file) {
        fileReader.readAsDataURL(file);
      }

      const file_name = Date.now() + "-" + file.name;
      const folder_name =
        this.state.tanggal_masuk.split("-")[0] +
        this.state.tanggal_masuk.split("-")[1];
      const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log(progress);
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref(`${folder_name}`)
            .child(file_name)
            .getDownloadURL()
            .then((url) => {
              console.log("URL " + url);
              this.setState({
                pemadanan_npwp_url: url,
                foto_pemadanan_npwp_status: "Upload selesai",
              });
              this.updateFileUrl("pemadanan_npwp");
              // Update validation status
              this.updateSubmitButtonStatus();
            });
        }
      );
    }
  };

  selectFotoSuratLamaran = (e) => {
    const file = e.target.files[0];

    // ✅ VALIDASI: Cek apakah file adalah gambar
    if (!this.validateImageFile(file)) {
      alert(
        "❌ Mohon maaf, hanya file gambar (JPG, JPEG, PNG, GIF) yang diperbolehkan!"
      );
      // Reset input file
      e.target.value = "";
      this.setState({
        foto_surat_lamaran_status: "File harus berupa gambar",
      });
      return;
    }
    // Batasi ukuran file hanya 3 MB
    var FileSize = e.target.files[0].size / 1024 / 1024; // in MiB
    if (FileSize > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MiB");
      this.setState({
        foto_surat_lamaran_status: "Melebihi ukuran maksimal",
      });
    } else {
      this.setState({
        suratLamaranFile: e.target.files[0],
        foto_surat_lamaran_label: e.target.files[0].name,
        foto_surat_lamaran_status: "Uploading...",
      });
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        this.setState({
          suratLamaranFile: file,
          suratLamaranUrl: fileReader.result,
        });
      };
      if (file) {
        fileReader.readAsDataURL(file);
      }

      const file_name = Date.now() + "-" + file.name;
      const folder_name =
        this.state.tanggal_masuk.split("-")[0] +
        this.state.tanggal_masuk.split("-")[1];
      const uploadTask = storage.ref(`${folder_name}/${file_name}`).put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          console.log(progress);
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref(`${folder_name}`)
            .child(file_name)
            .getDownloadURL()
            .then((url) => {
              console.log("URL " + url);
              this.setState({
                surat_lamaran_url: url,
                foto_surat_lamaran_status: "Upload selesai",
              });
              this.updateFileUrl("surat_lamaran");
              // Update validation status
              this.updateSubmitButtonStatus();
            });
        }
      );
    }
  };

  selectFotoFormulirLamaranPekerjaan = (e) => {
    if (!e.target.files || e.target.files.length === 0) return;
    const file = e.target.files[0];

    // ✅ UBAH: Validasi PDF instead of image
    if (!this.validatePdfFile(file)) {
      alert("❌ Mohon maaf, hanya file PDF yang diperbolehkan!");
      e.target.value = "";
      this.setState({
        foto_formulir_lamaran_pekerjaan_status: "File harus berupa PDF",
      });
      return;
    }

    // Maksimal 3 MB
    const size = file.size / 1024 / 1024;
    if (size > 3) {
      alert("Mohon maaf, ukuran file tidak boleh lebih dari 3 MB");
      this.setState({
        foto_formulir_lamaran_pekerjaan_status:
          "Melebihi ukuran maksimal (3MB)",
      });
      return;
    }

    this.setState({
      formulirLamaranPekerjaanFile: file,
      foto_formulir_lamaran_pekerjaan_label: file.name,
      foto_formulir_lamaran_pekerjaan_status: "Uploading...",
    });

    // ✅ UBAH: Untuk PDF, tidak perlu FileReader preview (atau bisa pakai PDF preview)
    // const fr = new FileReader();
    // fr.onloadend = () =>
    //   this.setState({ formulirLamaranPekerjaanUrl: fr.result });
    // fr.readAsDataURL(file);

    const file_name = Date.now() + "-" + file.name;
    const folder_name =
      this.state.tanggal_masuk.split("-")[0] +
      this.state.tanggal_masuk.split("-")[1];
    const task = storage.ref(`${folder_name}/${file_name}`).put(file);

    task.on(
      "state_changed",
      (snap) => {
        const prog = Math.round(
          (snap.bytesTransferred / snap.totalBytes) * 100
        );
        this.setState({
          foto_formulir_lamaran_pekerjaan_status: `Uploading... ${prog}%`,
        });
      },
      () =>
        this.setState({
          foto_formulir_lamaran_pekerjaan_status: "Upload gagal",
        }),
      () => {
        storage
          .ref(`${folder_name}`)
          .child(file_name)
          .getDownloadURL()
          .then((url) => {
            this.setState(
              {
                formulir_lamaran_pekerjaan_url: url,
                foto_formulir_lamaran_pekerjaan_status: "Upload selesai",
              },
              () => {
                this.updateFileUrl("formulir_lamaran_pekerjaan");
                this.updateSubmitButtonStatus();
              }
            );
          });
      }
    );
  };

  selectFotoFormulirOKB = (e) => {
    if (!e.target.files || e.target.files.length === 0) return;
    const file = e.target.files[0];
    if (!this.validateImageFile(file)) {
      e.target.value = "";
      this.setState({ foto_formulir_okb_status: "File harus berupa gambar" });
      return;
    }
    const size = file.size / 1024 / 1024;
    if (size > 3) {
      this.setState({ foto_formulir_okb_status: "Melebihi ukuran maksimal" });
      return;
    }
    this.setState({
      formulirOKBFile: file,
      foto_formulir_okb_label: file.name,
      foto_formulir_okb_status: "Uploading...",
    });

    const fr = new FileReader();
    fr.onloadend = () => this.setState({ formulirOKBUrl: fr.result });
    fr.readAsDataURL(file);

    const file_name = Date.now() + "-" + file.name;
    const folder_name =
      this.state.tanggal_masuk.split("-")[0] +
      this.state.tanggal_masuk.split("-")[1];
    const task = storage.ref(`${folder_name}/${file_name}`).put(file);

    task.on(
      "state_changed",
      (snap) => {
        const prog = Math.round(
          (snap.bytesTransferred / snap.totalBytes) * 100
        );
        this.setState({ foto_formulir_okb_status: `Uploading... ${prog}%` });
      },
      () => this.setState({ foto_formulir_okb_status: "Upload gagal" }),
      () => {
        storage
          .ref(`${folder_name}`)
          .child(file_name)
          .getDownloadURL()
          .then((url) => {
            this.setState(
              {
                formulir_okb_url: url,
                foto_formulir_okb_status: "Upload selesai",
              },
              () => {
                this.updateFileUrl("formulir_okb");
                this.updateSubmitButtonStatus();
              }
            );
          });
      }
    );
  };

  updateFileUrl = async (documentType, ocrMeta = {}) => {
    try {
      const {
        nik,
        nama_lengkap,
        tanggal_lahir,
        rekening_bank_url,
        mutasi_rekening_url,
        ijasah_url,
        transkrip_url,
        skck_url,
        bpjs_kesehatan_url,
        bpjs_ketenagakerjaan_url,
        keterangan_kesehatan_url,
        surat_pernyataan_kesanggupan_bpjs_url,
        keterangan_bpjs_tidak_aktif_url,
        peserta_jkn_url,
        iuran_jkn_url,
        vaksinasi_1_url,
        vaksinasi_2_url,
        vaksinasi_3_url,
        pemadanan_npwp_url,
        surat_lamaran_url,
        formulir_lamaran_pekerjaan_url,
        formulir_okb_url,
      } = this.state;

      if (!nik || !tanggal_lahir || !documentType) {
        throw new Error(
          "Missing required data: nik, tanggal_lahir, or documentType"
        );
      }

      let url = "";
      let fieldToUpdate = "";

      if (documentType === "rekening_bank") {
        url = rekening_bank_url;
        fieldToUpdate = "rekening_bank_url";
      } else if (documentType === "mutasi_rekening") {
        url = mutasi_rekening_url;
        fieldToUpdate = "mutasi_rekening_url";
      } else if (documentType === "ijasah") {
        url = ijasah_url;
        fieldToUpdate = "ijasah_url";
      } else if (documentType === "transkrip") {
        url = transkrip_url;
        fieldToUpdate = "transkrip_url";
      } else if (documentType === "skck") {
        url = skck_url;
        fieldToUpdate = "skck_url";
      } else if (documentType === "bpjs_kesehatan") {
        url = bpjs_kesehatan_url;
        fieldToUpdate = "bpjs_kesehatan_url";
      } else if (documentType === "bpjs_ketenagakerjaan") {
        url = bpjs_ketenagakerjaan_url;
        fieldToUpdate = "bpjs_ketenagakerjaan_url";
      } else if (documentType === "keterangan_kesehatan") {
        url = keterangan_kesehatan_url;
        fieldToUpdate = "keterangan_kesehatan_url";
      } else if (documentType === "surat_pernyataan_kesanggupan_bpjs") {
        url = surat_pernyataan_kesanggupan_bpjs_url;
        fieldToUpdate = "surat_pernyataan_kesanggupan_bpjs_url";
      } else if (documentType === "keterangan_bpjs_tidak_aktif") {
        url = keterangan_bpjs_tidak_aktif_url;
        fieldToUpdate = "keterangan_bpjs_tidak_aktif_url";
      } else if (documentType === "peserta_jkn") {
        url = peserta_jkn_url;
        fieldToUpdate = "peserta_jkn_url";
      } else if (documentType === "iuran_jkn") {
        url = iuran_jkn_url;
        fieldToUpdate = "iuran_jkn_url";
      } else if (documentType === "vaksinasi_1") {
        url = vaksinasi_1_url;
        fieldToUpdate = "vaksinasi_1_url";
      } else if (documentType === "vaksinasi_2") {
        url = vaksinasi_2_url;
        fieldToUpdate = "vaksinasi_2_url";
      } else if (documentType === "vaksinasi_3") {
        url = vaksinasi_3_url;
        fieldToUpdate = "vaksinasi_3_url";
      } else if (documentType === "pemadanan_npwp") {
        url = pemadanan_npwp_url;
        fieldToUpdate = "pemadanan_npwp_url";
      } else if (documentType === "surat_lamaran") {
        url = surat_lamaran_url;
        fieldToUpdate = "surat_lamaran_url";
      } else if (documentType === "formulir_lamaran_pekerjaan") {
        url = formulir_lamaran_pekerjaan_url;
        fieldToUpdate = "formulir_lamaran_pekerjaan_url";
      } else if (documentType === "formulir_okb") {
        url = formulir_okb_url;
        fieldToUpdate = "formulir_okb_url";
      } else {
        console.error("❌ Unknown document type:", documentType);
        return {
          success: false,
          error: "Unknown document type: " + documentType,
        };
      }

      // ✅ VALIDASI URL
      if (!url || url.trim() === "") {
        throw new Error(`Document URL not found for type: ${documentType}`);
      }

      console.log(`📋 Updating ${fieldToUpdate} for NIK: ${nik}`);

      const employeesRef = firebase.firestore().collection("employees");
      const session = JSON.parse(localStorage.getItem("id") || "[]")[0] || {};
      const resolved = await resolveEmployeeDoc(employeesRef, {
        docId: session.docId || null,
        nik,
        tanggalLahir: tanggal_lahir,
      });

      if (!resolved.doc) {
        throw new Error(`Employee document not found for NIK: ${nik}`);
      }

      const employeeDoc = resolved.doc;
      const updateData = {
        [fieldToUpdate]: url,
        updated_at: new Date().toISOString(),
      };

      const validateField =
        ocrMeta.validateField || getValidateByOcrFieldName(fieldToUpdate);
      if (validateField && typeof ocrMeta.validateByOcr === "boolean") {
        updateData[validateField] = ocrMeta.validateByOcr;
      }

      await employeeDoc.ref.update(updateData);

      if (session.docId !== employeeDoc.id) {
        session.docId = employeeDoc.id;
        localStorage.setItem("id", JSON.stringify([session]));
      }

      this.addQueue(documentType);

      console.log(
        `✅ Successfully updated ${fieldToUpdate} for employee: ${employeeDoc.id}`
      );
    } catch (error) {
      console.error("❌ Error in updateFileUrl:", error);
    }
  };

  getStorageFolder = () => {
    const parts = this.state.tanggal_masuk.split("-");
    return parts[0] + parts[1];
  };

  handleOcrPreviewChange = (previewKey, fileKey) => (previewUrl, file) => {
    this.setState({
      [previewKey]: previewUrl,
      [fileKey]: file,
    });
  };

  renderPipelineUpload = ({
    documentType,
    title,
    placeholderSrc,
    previewKey,
    fileKey,
    labelField,
    statusField,
    urlField,
    dbType,
    inputId,
    inputName,
    expectedName,
    expectedBank,
    expectedAccount,
    accept,
    fileTypeHint,
    previewMode,
    validateFile,
    requiredUrl,
    optional = false,
    colClass = "col-12 col-lg-6",
  }) => (
    <div className={colClass}>
    <DocumentOcrUpload
      documentType={documentType}
      userOcrEnabled={this.state.trial}
      expectedName={
        expectedName === undefined ? this.state.nama_lengkap : expectedName
      }
      expectedNik={this.state.nik}
      expectedBank={
        expectedBank === undefined ? this.state.selected_bank : expectedBank
      }
      expectedAccount={
        expectedAccount === undefined
          ? this.state.nomor_rekening_bank
          : expectedAccount
      }
      title={title}
      placeholderSrc={placeholderSrc}
      previewUrl={this.state[previewKey]}
      fileLabel={this.state[labelField]}
      uploadStatus={this.state[statusField]}
      inputId={inputId}
      inputName={inputName}
      required={
        !optional &&
        !(
          typeof this.state[requiredUrl || urlField] === "string" &&
          this.state[requiredUrl || urlField].trim() !== ""
        )
      }
      storageFolder={this.getStorageFolder()}
      validateImageFile={validateFile ? undefined : this.validateImageFile}
      validateFile={validateFile}
      accept={accept}
      fileTypeHint={fileTypeHint}
      previewMode={previewMode}
      onPreviewChange={this.handleOcrPreviewChange(previewKey, fileKey)}
      onStatusChange={(status) => this.setState({ [statusField]: status })}
      onLabelChange={(label) => this.setState({ [labelField]: label })}
      onUploadComplete={this.handleOcrUploadComplete(
        urlField,
        statusField,
        dbType,
      )}
    />
    </div>
  );

  handleOcrUploadComplete = (urlField, statusField, documentTypeForDb) => (
    url,
    _file,
    meta = {}
  ) => {
    const validateByOcr = meta.validate_by_ocr === true;
    const validateField = getValidateByOcrFieldName(urlField);
    const updates = {
      [urlField]: url,
      [statusField]: "Upload selesai",
    };
    if (validateField) {
      updates[validateField] = validateByOcr;
    }
    if (meta.issued_date && urlField === "keterangan_kesehatan_url") {
      updates.tanggal_pembuatan_surat_keterangan_sehat = meta.issued_date;
    }
    this.setState(updates, () => {
      if (documentTypeForDb) {
        this.updateFileUrl(documentTypeForDb, {
          validateField,
          validateByOcr,
        });
      }
      this.updateSubmitButtonStatus();
    });
  };

  //function untuk validasi tipe file yang diupload
  validateImageFile = (file) => {
    // ✅ TAMBAH: Validasi apakah file ada
    if (!file) {
      console.log("❌ No file selected");
      return false;
    }

    const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
    const allowedExtensions = [".jpg", ".jpeg", ".png", ".webp"];

    // ✅ TAMBAH: Validasi apakah file memiliki property type
    if (!file.type) {
      console.log("❌ File has no type property");
      return false;
    }

    // Validasi berdasarkan MIME type
    if (!allowedTypes.includes(file.type)) {
      console.log("❌ Invalid file type:", file.type);
      return false;
    }

    // ✅ TAMBAH: Validasi apakah file memiliki property name
    if (!file.name) {
      console.log("❌ File has no name property");
      return false;
    }

    // Validasi berdasarkan ekstensi file
    const fileName = file.name.toLowerCase();
    const hasValidExtension = allowedExtensions.some((ext) =>
      fileName.endsWith(ext)
    );

    if (!hasValidExtension) {
      console.log("❌ Invalid file extension:", fileName);
      return false;
    }

    console.log("✅ File validation passed:", fileName, file.type);
    return true;
  };

  validatePdfFile = (file) => {
    if (!file) {
      console.log("❌ No file selected");
      return false;
    }

    const allowedTypes = ["application/pdf"];
    const allowedExtensions = [".pdf"];

    if (!file.type) {
      console.log("❌ File has no type property");
      return false;
    }

    // Validasi berdasarkan MIME type
    if (!allowedTypes.includes(file.type)) {
      console.log("❌ Invalid file type:", file.type);
      return false;
    }

    if (!file.name) {
      console.log("❌ File has no name property");
      return false;
    }

    // Validasi berdasarkan ekstensi file
    const fileName = file.name.toLowerCase();
    const hasValidExtension = allowedExtensions.some((ext) =>
      fileName.endsWith(ext)
    );

    if (!hasValidExtension) {
      console.log("❌ Invalid file extension:", fileName);
      return false;
    }

    console.log("✅ PDF validation passed:", fileName, file.type);
    return true;
  };

  validateRekeningBank = (e) => {
    const rawInputValue = e.target.value;
    const inputValue = rawInputValue ? rawInputValue.toString() : "";
    const { selected_bank, status_karyawan } = this.state;

    console.log("🔍 Validating rekening bank:", {
      rawInputValue,
      inputValue,
      inputType: typeof inputValue,
      selected_bank,
      status_karyawan,
      inputLength: inputValue.length,
    });

    if (typeof inputValue !== "string") {
      console.error("❌ InputValue is not a string:", inputValue);
      return;
    }

    // Hanya izinkan angka dan hapus karakter non-digit
    const numericValue = inputValue.replace(/\D/g, "");

    // Tentukan batas maksimal berdasarkan bank atau status karyawan
    let maxDigits = 0;
    let bankType = selected_bank;

    // ✅ Untuk staff, selalu MAS
    if (status_karyawan === "staff") {
      maxDigits = 10;
      bankType = "mas";

      if (selected_bank !== "mas") {
        this.setState({ selected_bank: "mas" });
      }
    }
    // ✅ Untuk nonstaff, cek berdasarkan bank yang dipilih ATAU prediksi dari panjang digit
    else if (isNonstaffStatus(status_karyawan)) {
      if (selected_bank === "mandiri") {
        maxDigits = 13;
        bankType = "mandiri";
      } else if (selected_bank === "mas") {
        maxDigits = 10;
        bankType = "mas";
      } else if (selected_bank === "" && numericValue.length > 0) {
        if (numericValue.length <= 10) {
          maxDigits = 10;
          bankType = "mas";
          console.log("🤖 Auto-detecting MAS bank based on digit length");
        } else if (numericValue.length <= 13) {
          maxDigits = 13;
          bankType = "mandiri";
          console.log("🤖 Auto-detecting Mandiri bank based on digit length");
        } else {
          maxDigits = 13;
          bankType = "mandiri";
        }

        // ✅ Auto-set bank yang terdeteksi hanya jika tidak ada data MCU
        if (
          bankType &&
          this.state.selected_bank === "" &&
          !this.state.nomor_rekening_bank_mcu
        ) {
          this.setState({ selected_bank: bankType });
        }
      }
    }

    // Potong jika melebihi batas maksimal
    const limitedValue =
      maxDigits > 0 ? numericValue.substring(0, maxDigits) : numericValue;

    // Update state dengan nilai yang sudah dibatasi
    this.setState(
      {
        nomor_rekening_bank: limitedValue,
      },
      () => {
        // Validasi dan set error message
        let error = "";
        let isValidLength = false;

        if (status_karyawan === "staff") {
          isValidLength = limitedValue.length === 10;
          if (limitedValue.length > 0 && !isValidLength) {
            error = `Nomor rekening MAS: ${limitedValue.length}/10 digit`;
          }
        } else if (isNonstaffStatus(status_karyawan)) {
          if (bankType === "mandiri") {
            isValidLength = limitedValue.length === 13;
            if (limitedValue.length > 0 && !isValidLength) {
              error = `Nomor rekening Mandiri: ${limitedValue.length}/13 digit`;
            }
          } else if (bankType === "mas") {
            isValidLength = limitedValue.length === 10;
            if (limitedValue.length > 0 && !isValidLength) {
              error = `Nomor rekening MAS: ${limitedValue.length}/10 digit`;
            }
          } else if (limitedValue.length > 0) {
            error = "Pilih bank yang sesuai dengan nomor rekening";
          }
        }

        this.setState(
          {
            rekening_error: error,
          },
          () => {
            this.queueAutosave({
              nomor_rekening_bank: limitedValue,
              selected_bank: this.state.selected_bank,
            });
            setTimeout(() => {
              this.updateSubmitButtonStatus();
            }, 100);
          }
        );

        console.log("✅ Rekening validation result:", {
          limitedValue,
          length: limitedValue.length,
          requiredLength: maxDigits,
          detectedBank: bankType,
          isValidLength,
          error,
        });
      }
    );
  };

  getFieldDisplayName = (fieldName) => {
    const fieldNames = {
      // Field rekening
      selected_bank: "Pilih Bank",
      nomor_rekening_bank: "Nomor Rekening Bank",

      // Field form data
      tanggal_berlaku_skck: "Tanggal Berlaku SKCK",
      bpjs_status: "Status BPJS",
      status_iuran: "Status Iuran JKN",
      tanggal_pembuatan_surat_keterangan_sehat:
        "Tanggal Berlaku Keterangan Sehat",

      // Agreement
      agreement: "Persetujuan (Checklist)",
    };

    return fieldNames[fieldName] || fieldName;
  };

  // validateRekeningBankWithMCU = async (newValue) => {
  //   const mcuRekeningValue = this.state.nomor_rekening_bank_mcu;
  //   const { status_karyawan, selected_bank } = this.state;

  //   console.log("🏦 Validating rekening with MCU:", {
  //     newValue,
  //     mcuValue: mcuRekeningValue,
  //     status_karyawan,
  //     selected_bank,
  //   });

  //   // ✅ Validasi format terlebih dahulu
  //   const formatValidation = this.validateRekeningFormat(
  //     newValue,
  //     selected_bank,
  //     status_karyawan
  //   );

  //   if (!formatValidation.isValid) {
  //     await Swal.fire({
  //       title: "Format Rekening Salah!",
  //       text: formatValidation.message,
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     });

  //     // Reset ke nilai MCU jika ada, atau kosongkan
  //     this.setState({
  //       nomor_rekening_bank: mcuRekeningValue || "",
  //       rekening_error: "",
  //     });
  //     return;
  //   }

  //   // ✅ Cek apakah ada data MCU untuk dibandingkan
  //   if (
  //     mcuRekeningValue &&
  //     mcuRekeningValue !== "" &&
  //     mcuRekeningValue !== newValue
  //   ) {
  //     // ✅ Popup konfirmasi dengan SweetAlert2
  //     const result = await Swal.fire({
  //       title: `Nomor Rekening Bank Berubah!`,
  //       html: `
  //       <div style="text-align: left;">
  //         <p><strong>Data MCU:</strong> ${mcuRekeningValue}</p>
  //         <p><strong>Data Baru:</strong> ${newValue}</p>
  //         <br>
  //         <p>Pilih data yang ingin digunakan:</p>
  //       </div>
  //     `,
  //       icon: "question",
  //       showCancelButton: true,
  //       confirmButtonColor: "#3085d6",
  //       cancelButtonColor: "#6c757d",
  //       confirmButtonText: "✅ Gunakan Data Baru",
  //       cancelButtonText: "↩️ Gunakan Data MCU",
  //       reverseButtons: true,
  //     });

  //     if (result.isConfirmed) {
  //       // Gunakan data baru
  //       this.setState(
  //         {
  //           nomor_rekening_bank: newValue,
  //           rekening_error: "",
  //         },
  //         () => {
  //           this.updateSubmitButtonStatus();
  //           Swal.fire({
  //             title: "Berhasil!",
  //             text: `Nomor rekening bank berhasil diperbarui`,
  //             icon: "success",
  //             timer: 2000,
  //             showConfirmButton: false,
  //           });
  //         }
  //       );
  //     } else {
  //       // Gunakan data MCU
  //       this.setState(
  //         {
  //           nomor_rekening_bank: mcuRekeningValue,
  //           rekening_error: "",
  //         },
  //         () => {
  //           this.updateSubmitButtonStatus();
  //           Swal.fire({
  //             title: "Data Dikembalikan",
  //             text: `Menggunakan nomor rekening dari MCU`,
  //             icon: "info",
  //             timer: 2000,
  //             showConfirmButton: false,
  //           });
  //         }
  //       );
  //     }
  //   } else {
  //     // ✅ Tidak ada data MCU atau sama, hanya update validation
  //     this.updateSubmitButtonStatus();
  //   }
  // };

  // validateRekeningFormat = (value, selectedBank, statusKaryawan) => {
  //   if (!value || value.length === 0) {
  //     return { isValid: true }; // Kosong boleh untuk sementara
  //   }

  //   // Hanya angka
  //   if (!/^\d+$/.test(value)) {
  //     return {
  //       isValid: false,
  //       message: "Nomor rekening hanya boleh berisi angka!",
  //     };
  //   }

  //   // ✅ Validasi berdasarkan status karyawan dan bank
  //   if (statusKaryawan === "staff") {
  //     if (value.length !== 10) {
  //       return {
  //         isValid: false,
  //         message: "Nomor rekening MAS harus tepat 10 digit!",
  //       };
  //     }
  //   } else if (statusKaryawan === "nonstaff") {
  //     if (selectedBank === "mandiri") {
  //       if (value.length !== 13) {
  //         return {
  //           isValid: false,
  //           message: "Nomor rekening Mandiri harus tepat 13 digit!",
  //         };
  //       }
  //     } else if (selectedBank === "mas") {
  //       if (value.length !== 10) {
  //         return {
  //           isValid: false,
  //           message: "Nomor rekening MAS harus tepat 10 digit!",
  //         };
  //       }
  //     } else if (selectedBank === "") {
  //       // ✅ Auto-detect berdasarkan panjang
  //       if (value.length !== 10 && value.length !== 13) {
  //         return {
  //           isValid: false,
  //           message:
  //             "Nomor rekening harus 10 digit (MAS) atau 13 digit (Mandiri)!",
  //         };
  //       }
  //     }
  //   }

  //   return { isValid: true };
  // };

  onChange = (e) => {
    const { name, value, type } = e.target;
    console.log("📝 Field changed:", name, "=", value);

    this.setState({ [name]: value }, () => {
      this.queueAutosave({ [name]: value });
      if (type === "radio") {
        this.flushAutosave();
      }
      setTimeout(() => {
        this.updateSubmitButtonStatus();
      }, 0);
    });
  };

  // onRadioChange = (e) => {
  //   const fieldName = e.target.name;
  //   const newValue = e.target.value;

  //   console.log(`📝 Radio changed: ${fieldName} = ${newValue}`);

  //   // ✅ STEP 1: Update state terlebih dahulu
  //   const state = this.state;
  //   state[fieldName] = newValue;
  //   this.setState(state, () => {
  //     // ✅ STEP 2: Setelah state terupdate, lakukan validasi dengan delay
  //     setTimeout(() => {
  //       this.validateFieldChangeWithSwal(fieldName, newValue);
  //       this.updateSubmitButtonStatus();
  //     }, 300); // ✅ Delay 300ms untuk memastikan state sudah terupdate
  //   });
  // };

  onBankChange = (e) => {
    const selectedBank = e.target.value;

    console.log("🏦 Bank selection changed:", {
      from: this.state.selected_bank,
      to: selectedBank,
      status_karyawan: this.state.status_karyawan,
    });

    if (this.state.status_karyawan === "staff" && selectedBank !== "mas") {
      console.log("❌ Staff hanya boleh pilih MAS");
      return;
    }

    this.setState(
      {
        selected_bank: selectedBank,
        // nomor_rekening_bank: "", // Reset nomor rekening saat ganti bank
        rekening_error: "", // Reset error
      },
      () => {
        console.log("✅ Bank selection updated:", {
          selected_bank: this.state.selected_bank,
          // nomor_rekening_bank: this.state.nomor_rekening_bank,
        });

        this.queueAutosave({ selected_bank: this.state.selected_bank });
        this.flushAutosave();

        // Update submit button status setelah bank berubah
        setTimeout(() => {
          this.updateSubmitButtonStatus();
        }, 100);
      }
    );
  };

  _onBlur = (e) => {
    const fieldName = e.target.name;
    const newValue = e.target.value.trim();

    console.log(
      `🔍 onBlur triggered for field: ${fieldName}, new value: ${newValue}`
    );
  };

  handleAutosaveBlur = (e) => {
    const el = e.target;
    if (!el || !el.name) return;
    if (el.type === "file") return;
    if (el.type === "button" || el.type === "submit") return;

    const fieldName = el.name;
    let fieldValue = el.value;
    if (el.type === "checkbox") {
      fieldValue = el.checked;
    } else if (
      el.type === "text" ||
      el.type === "tel" ||
      el.type === "number" ||
      el.type === "date" ||
      el.type === "email" ||
      el.tagName === "TEXTAREA"
    ) {
      fieldValue = typeof fieldValue === "string" ? fieldValue.trim() : fieldValue;
    }

    this.queueAutosave({ [fieldName]: fieldValue });
    this.flushAutosave();
  };

  agreementChange = (e) => {
    console.log("🔘 Agreement checkbox clicked Form2");

    this.setState(
      (prevState) => ({
        agreement: !prevState.agreement,
      }),
      () => {
        console.log("✅ Agreement updated to:", this.state.agreement);
        this.queueAutosave({ agreement: this.state.agreement });
        this.flushAutosave();
        setTimeout(() => {
          this.updateSubmitButtonStatus();
        }, 100);
      }
    );
  };

  getEmployeeDocRef = async () => {
    const raw = localStorage.getItem("id");
    if (!raw) return null;

    const userData = JSON.parse(raw)[0];
    if (!userData) return null;

    try {
      const resolved = await resolveEmployeeDoc(this.ref, {
        docId: userData.docId || null,
        nik: userData.nik,
        tanggalLahir: userData.tanggal_lahir,
      });

      if (!resolved.doc) {
        console.warn("⚠️ Document tidak ditemukan untuk autosave Form 2");
        return null;
      }

      if (resolved.docs.length > 1) {
        console.warn(
          "⚠️ Autosave Form 2: ada",
          resolved.docs.length,
          "dokumen untuk NIK yang sama; memakai yang terbaru:",
          resolved.doc.id,
        );
      }

      if (userData.docId !== resolved.doc.id) {
        userData.docId = resolved.doc.id;
        localStorage.setItem("id", JSON.stringify([userData]));
      }

      return this.ref.doc(resolved.doc.id);
    } catch (error) {
      console.error("❌ Error resolve employee doc Form 2:", error);
      return null;
    }
  };

  queueAutosave = (fields) => {
    if (!fields || typeof fields !== "object") return;
    Object.assign(this.pendingAutosave, fields);
    if (this.autosaveTimer) {
      clearTimeout(this.autosaveTimer);
    }
    this.autosaveTimer = setTimeout(() => {
      const payload = { ...this.pendingAutosave };
      this.pendingAutosave = {};
      this.autosaveTimer = null;
      this.saveFieldsToDatabase(payload);
    }, 700);
  };

  flushAutosave = () => {
    if (this.autosaveTimer) {
      clearTimeout(this.autosaveTimer);
      this.autosaveTimer = null;
    }
    const payload = { ...this.pendingAutosave };
    this.pendingAutosave = {};
    if (Object.keys(payload).length > 0) {
      return this.saveFieldsToDatabase(payload);
    }
    return Promise.resolve();
  };

  saveFieldsToDatabase = async (fields) => {
    try {
      if (!fields || typeof fields !== "object") return;

      const sanitized = {};
      Object.keys(fields).forEach((key) => {
        const value = fields[key];
        if (value === undefined) return;
        if (typeof File !== "undefined" && value instanceof File) return;
        if (typeof Blob !== "undefined" && value instanceof Blob) return;
        sanitized[key] = value;
      });

      if (Object.keys(sanitized).length === 0) return;

      const docRef = await this.getEmployeeDocRef();
      if (!docRef) return;

      await docRef.update({
        ...sanitized,
        updated_at: new Date().toISOString(),
      });

      console.log("💾 Autosave Form 2:", Object.keys(sanitized));
    } catch (error) {
      console.error("❌ Error autosave Form 2:", error);
    }
  };

  handleLogout = () => {
    localStorage.removeItem("id");
    this.props.history.push("/");
  };

  canOpenForm3 = () => {
    try {
      const stored = JSON.parse(localStorage.getItem("id") || "[]")[0] || {};
      return (
        stored.form_1_submitted === "diisi" &&
        stored.form_2_submitted === "diisi"
      );
    } catch (err) {
      return false;
    }
  };

  goToForm1 = (e) => {
    if (e) e.preventDefault();
    this.flushAutosave();
    this.props.history.push("/form");
  };

  goToForm2 = (e) => {
    if (e) e.preventDefault();
    this.flushAutosave();
    this.props.history.push("/form-2");
  };

  goToForm3 = (e) => {
    if (e) e.preventDefault();
    if (!this.canOpenForm3()) return;
    this.flushAutosave();
    this.props.history.push("/form-3");
  };

  currentDate = () => {
    let date = new Date();
    return (
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
    );
  };

  _onFocus = (e) => {
    e.currentTarget.type = "date";
  };

  onCheckboxChange = (e) => {
    // console.log("Checkbox changed:", e.target.name, e.target.checked);
    this.setState({
      [e.target.name]: e.target.checked,
    });
  };

  updateExistingEmployee = async (employeeData) => {
    try {
      const userData = JSON.parse(localStorage.getItem("id"))[0];
      const nik = userData.nik;
      const tanggal_lahir = userData.tanggal_lahir;

      console.log("🔄 Updating employee data for NIK:", nik);

      const resolved = await resolveEmployeeDoc(this.ref, {
        docId: userData.docId || null,
        nik,
        tanggalLahir: tanggal_lahir,
      });

      if (!resolved.doc) {
        throw new Error("Employee data not found");
      }

      if (resolved.docs.length > 1) {
        console.warn(
          "⚠️ Form2: ada",
          resolved.docs.length,
          "dokumen untuk NIK yang sama; memakai yang terbaru:",
          resolved.doc.id,
        );
      }

      const docRef = this.ref.doc(resolved.doc.id);
      userData.docId = resolved.doc.id;
      localStorage.setItem("id", JSON.stringify([userData]));

      await docRef.update({
        ...employeeData,
        form_2_submitted: "diisi",
        form_2_submitted_date: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      });

      console.log("✅ Successfully updated employee data");
      return { success: true, docId: docRef.id };
    } catch (error) {
      console.error("❌ Error updating employee:", error);
      return { success: false, error: error.message };
    }
  };

  isBpjsKetenagakerjaanUploadRequired = () => {
    const keterangan = (
      this.state.keterangan_kartu_bpjs_ketenagakerjaan || ""
    ).trim();
    return keterangan !== "Belum Dapat";
  };

  validateRequiredFields = () => {
    console.log("🔍 Processing Validate Required Fields Form2");
    const {
      // ✅ TAMBAH: Field rekening bank
      // selected_bank,
      // nomor_rekening_bank,
      status_karyawan,

      // // ✅ FIELD VAKSINASI WAJIB
      // jenis_vaksin,
      // tanggal_vaksin_1,
      // lokasi_vaksin_1,

      // ✅ FIELD FORM DATA WAJIB
      tanggal_berlaku_skck,
      bpjs_status,
      status_iuran,

      // ✅ FIELD UPLOAD WAJIB (UNIVERSAL)
      rekening_bank_url,
      mutasi_rekening_url,
      ijasah_url,
      transkrip_url,
      skck_url,
      peserta_jkn_url,
      iuran_jkn_url,
      surat_pernyataan_kesanggupan_bpjs_url,
      keterangan_bpjs_tidak_aktif_url,
      vaksinasi_1_url,
      pemadanan_npwp_url,
      surat_lamaran_url,
      formulir_lamaran_pekerjaan_url,
      formulir_okb_url,

      // ✅ STATUS UPLOAD WAJIB (UNIVERSAL)
      foto_rekening_bank_status,
      foto_mutasi_rekening_status,
      foto_ijasah_status,
      foto_transkrip_status,
      foto_skck_status,
      foto_peserta_jkn_status,
      foto_iuran_jkn_status,
      foto_vaksinasi_1_status,
      foto_pemadanan_npwp_status,
      foto_surat_lamaran_status,
      foto_formulir_lamaran_pekerjaan_status,
      foto_formulir_okb_status,
      foto_bpjs_ketenagakerjaan_status,
      bpjs_ketenagakerjaan_url,

      // ✅ FIELD CONDITIONAL BPJS AKTIF
      bpjs_kesehatan_url,
      keterangan_kesehatan_url,
      foto_bpjs_kesehatan_status,
      foto_keterangan_kesehatan_status,
      tanggal_pembuatan_surat_keterangan_sehat,
      // nomor_kartu_bpjs_kesehatan,

      // ✅ FIELD CONDITIONAL BPJS TIDAK AKTIF
      foto_surat_pernyataan_kesanggupan_bpjs_status,
      foto_keterangan_bpjs_tidak_aktif_status,

      // ✅ AGREEMENT
      agreement,
    } = this.state;

    const safeTrim = (value) => {
      return value && typeof value === "string" ? value.trim() : "";
    };

    const safeBool = (value) => {
      return value === true;
    };

    const safeCheck = (value) => {
      return value !== null && value !== undefined && value !== "";
    };

    const isUploadComplete = (status) => {
      return status === "Upload selesai";
    };

    // ✅ VALIDASI: Field dasar yang wajib diisi
    const basicFieldChecks = {
      // nomor_rekening_bank: safeTrim(nomor_rekening_bank) !== "",
      // jenis_vaksin: safeTrim(jenis_vaksin) !== "",
      // tanggal_vaksin_1: safeTrim(tanggal_vaksin_1) !== "",
      // lokasi_vaksin_1: safeTrim(lokasi_vaksin_1) !== "",
      tanggal_berlaku_skck: safeTrim(tanggal_berlaku_skck) !== "",
      bpjs_status: safeTrim(bpjs_status) !== "",
      status_iuran: safeTrim(status_iuran) !== "",
      agreement: safeBool(agreement),
    };

    // ✅ DEBUG: Tampilkan field yang gagal
    const failedBasicFields = Object.entries(basicFieldChecks)
      .filter(([key, value]) => !value)
      .map(([key]) => key);

    if (failedBasicFields.length > 0) {
      console.log("❌ Basic fields yang belum diisi:", failedBasicFields);
    }

    const basicFieldsValid = Object.values(basicFieldChecks).every(Boolean);

    // ✅ VALIDASI: Upload files wajib (UNIVERSAL - selalu dibutuhkan)
    const requiredUploadChecks = {
      ...(status_karyawan === "staff" || isNonstaffStatus(status_karyawan)
        ? {
            rekening_bank_complete: isUploadComplete(foto_rekening_bank_status),
            mutasi_rekening_complete: isUploadComplete(
              foto_mutasi_rekening_status
            ),
            rekening_bank_url_exists: safeCheck(rekening_bank_url),
            mutasi_rekening_url_exists: safeCheck(mutasi_rekening_url),
          }
        : {}),
      // rekening_bank_complete: isUploadComplete(foto_rekening_bank_status),
      // mutasi_rekening_complete: isUploadComplete(foto_mutasi_rekening_status),
      ijasah_complete: isUploadComplete(foto_ijasah_status),
      transkrip_complete: isUploadComplete(foto_transkrip_status),
      skck_complete: isUploadComplete(foto_skck_status),
      peserta_jkn_complete: isUploadComplete(foto_peserta_jkn_status),
      iuran_jkn_complete: isUploadComplete(foto_iuran_jkn_status),
      vaksinasi_1_complete: isUploadComplete(foto_vaksinasi_1_status),
      pemadanan_npwp_complete: isUploadComplete(foto_pemadanan_npwp_status),
      surat_lamaran_complete: isUploadComplete(foto_surat_lamaran_status),
      formulir_lamaran_pekerjaan_complete: isUploadComplete(
        foto_formulir_lamaran_pekerjaan_status
      ),
      formulir_okb_complete: isUploadComplete(foto_formulir_okb_status),

      // rekening_bank_url_exists: safeCheck(rekening_bank_url),
      // mutasi_rekening_url_exists: safeCheck(mutasi_rekening_url),
      ijasah_url_exists: safeCheck(ijasah_url),
      transkrip_url_exists: safeCheck(transkrip_url),
      skck_url_exists: safeCheck(skck_url),
      peserta_jkn_url_exists: safeCheck(peserta_jkn_url),
      iuran_jkn_url_exists: safeCheck(iuran_jkn_url),
      vaksinasi_1_url_exists: safeCheck(vaksinasi_1_url),
      pemadanan_npwp_url_exists: safeCheck(pemadanan_npwp_url),
      surat_lamaran_url_exists: safeCheck(surat_lamaran_url),
      formulir_lamaran_pekerjaan_url_exists: safeCheck(
        formulir_lamaran_pekerjaan_url
      ),
      formulir_okb_url_exists: safeCheck(formulir_okb_url),
      ...(this.isBpjsKetenagakerjaanUploadRequired()
        ? {
            bpjs_ketenagakerjaan_complete: isUploadComplete(
              foto_bpjs_ketenagakerjaan_status
            ),
            bpjs_ketenagakerjaan_url_exists: safeCheck(
              bpjs_ketenagakerjaan_url
            ),
          }
        : {}),
    };

    // console.log(requiredUploadChecks);

    const failedRequiredUploads = Object.entries(requiredUploadChecks)
      .filter(([key, value]) => !value)
      .map(([key]) => key);

    if (failedRequiredUploads.length > 0) {
      console.log(
        "❌ Required uploads yang belum selesai:",
        failedRequiredUploads
      );
    }

    const requiredUploadsValid =
      Object.values(requiredUploadChecks).every(Boolean);

    // ✅ VALIDASI: Upload files conditional berdasarkan BPJS status
    let conditionalUploadsValid = true;

    if (bpjs_status === "active") {
      // ✅ JIKA BPJS AKTIF: Hanya butuh 4 field ini
      const activeUploads = {
        bpjs_kesehatan_complete: isUploadComplete(foto_bpjs_kesehatan_status),
        keterangan_kesehatan_complete: isUploadComplete(
          foto_keterangan_kesehatan_status
        ),
        bpjs_kesehatan_url_exists: safeCheck(bpjs_kesehatan_url),
        keterangan_kesehatan_url_exists: safeCheck(keterangan_kesehatan_url),
        // nomor_kartu_bpjs_kesehatan_filled:
        //   safeTrim(nomor_kartu_bpjs_kesehatan) !== "",
        tanggal_pembuatan_surat_keterangan_sehat_filled:
          safeTrim(tanggal_pembuatan_surat_keterangan_sehat) !== "",
      };

      const failedActiveUploads = Object.entries(activeUploads)
        .filter(([key, value]) => !value)
        .map(([key]) => key);

      if (failedActiveUploads.length > 0) {
        console.log(
          "❌ BPJS Active fields yang belum selesai:",
          failedActiveUploads
        );
      }

      conditionalUploadsValid = Object.values(activeUploads).every(Boolean);
    } else if (bpjs_status === "not_active") {
      // ✅ JIKA BPJS TIDAK AKTIF: Hanya butuh 1 field ini
      const inactiveUploads = {
        bpjs_kesehatan_complete: isUploadComplete(foto_bpjs_kesehatan_status),
        keterangan_kesehatan_complete: isUploadComplete(
          foto_keterangan_kesehatan_status
        ),
        bpjs_kesehatan_url_exists: safeCheck(bpjs_kesehatan_url),
        keterangan_kesehatan_url_exists: safeCheck(keterangan_kesehatan_url),
        // nomor_kartu_bpjs_kesehatan_filled:
        //   safeTrim(nomor_kartu_bpjs_kesehatan) !== "",
        tanggal_pembuatan_surat_keterangan_sehat_filled:
          safeTrim(tanggal_pembuatan_surat_keterangan_sehat) !== "",
        surat_pernyataan_kesanggupan_bpjs_complete: isUploadComplete(
          foto_surat_pernyataan_kesanggupan_bpjs_status
        ),
        surat_pernyataan_kesanggupan_bpjs_url_exists: safeCheck(
          surat_pernyataan_kesanggupan_bpjs_url
        ),
        bpjs_tidak_aktif_complete: isUploadComplete(
          foto_keterangan_bpjs_tidak_aktif_status
        ),
        bpjs_tidak_aktif_url_exists: safeCheck(keterangan_bpjs_tidak_aktif_url),
      };

      const failedInactiveUploads = Object.entries(inactiveUploads)
        .filter(([key, value]) => !value)
        .map(([key]) => key);

      if (failedInactiveUploads.length > 0) {
        console.log(
          "❌ BPJS Inactive uploads yang belum selesai:",
          failedInactiveUploads
        );
      }

      conditionalUploadsValid = Object.values(inactiveUploads).every(Boolean);
    }

    // ✅ FINAL RESULT
    const finalResult =
      basicFieldsValid && requiredUploadsValid && conditionalUploadsValid;

    // ✅ DEBUG: Log hasil validasi untuk troubleshooting
    console.log("🔍 Validation result:", {
      basicFieldsValid,
      requiredUploadsValid,
      conditionalUploadsValid,
      finalResult,
      failedBasicFields,
      failedRequiredUploads,
      status_karyawan,
      bpjs_status,
    });

    return finalResult;
  };

  //  Method untuk update submit button status
  updateSubmitButtonStatus = () => {
    console.log("🔘 Update Submit Button Status Form2");
    try {
      const isFormValid = this.validateRequiredFields();
      if (this.state.isFormValid !== isFormValid) {
        this.setState({ isFormValid });
      }
    } catch (error) {
      console.error("Error in updateSubmitButtonStatus Form2:", error);
      if (this.state.isFormValid !== false) {
        this.setState({ isFormValid: false });
      }
    }
  };

  validateFieldChangeWithSwal = async (fieldName, newValue) => {
    const mcuFieldName = `${fieldName}_mcu`;
    const mcuValue = this.state[mcuFieldName];

    const normalizeValue = (value) => {
      if (!value || typeof value !== "string") return "";

      return value
        .toString()
        .trim() // Hapus whitespace di awal/akhir
        .toLowerCase() // Ubah ke lowercase
        .replace(/\s+/g, " ") // Ganti multiple spaces dengan single space
        .replace(/[^\w\s]/g, "") // Hapus karakter khusus (opsional)
        .normalize("NFD") // Normalisasi unicode
        .replace(/[\u0300-\u036f]/g, ""); // Hapus diacritics (á → a, é → e)
    };

    const normalizedNewValue = normalizeValue(newValue);
    const normalizedMcuValue = normalizeValue(mcuValue);

    // ✅ DEBUG: Console log untuk troubleshooting
    console.log(`🔍 Comparing field: ${fieldName}`);
    console.log(`📊 Original MCU: "${mcuValue}"`);
    console.log(`📊 Original New: "${newValue}"`);
    console.log(`🔧 Normalized MCU: "${normalizedMcuValue}"`);
    console.log(`🔧 Normalized New: "${normalizedNewValue}"`);
    console.log(`⚖️ Are equal: ${normalizedMcuValue === normalizedNewValue}`);

    if (
      mcuValue &&
      mcuValue !== "" &&
      normalizedMcuValue !== normalizedNewValue
    ) {
      // Validasi format field
      const validationResult = this.validateFieldFormat(fieldName, newValue);

      if (!validationResult.isValid) {
        await Swal.fire({
          title: "Format Data Salah!",
          text: validationResult.message,
          icon: "error",
          confirmButtonText: "OK",
        });
        this.setState({ [fieldName]: mcuValue });
        return;
      }

      // Popup konfirmasi dengan SweetAlert2
      const fieldDisplayName = this.getFieldDisplayName(fieldName);
      const result = await Swal.fire({
        title: `Data ${fieldDisplayName} Berubah!`,
        html: `
          <div style="text-align: left;">
            <p><strong>Data MCU:</strong> ${mcuValue}</p>
            <p><strong>Data Baru:</strong> ${newValue}</p>
            <br>
            <p>Pilih data yang ingin digunakan:</p>
          </div>
        `,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "✅ Gunakan Data Baru",
        cancelButtonText: "↩️ Gunakan Data MCU",
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        // Gunakan data baru
        this.setState({ [fieldName]: newValue }, () => {
          this.updateSubmitButtonStatus();
          Swal.fire({
            title: "Berhasil!",
            text: `Data ${fieldDisplayName} berhasil diperbarui`,
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
        });
      } else {
        // Gunakan data MCU
        this.setState({ [fieldName]: mcuValue }, () => {
          this.updateSubmitButtonStatus();
          Swal.fire({
            title: "Data Dikembalikan",
            text: `Menggunakan data ${fieldDisplayName} dari MCU`,
            icon: "info",
            timer: 2000,
            showConfirmButton: false,
          });
        });
      }
    } else if (newValue.length > 0) {
      const validationResult = this.validateFieldFormat(fieldName, newValue);

      if (!validationResult.isValid) {
        await Swal.fire({
          title: "Format Data Salah!",
          text: validationResult.message,
          icon: "error",
          confirmButtonText: "OK",
        });
        this.setState({ [fieldName]: mcuValue || "" });
      } else {
        this.updateSubmitButtonStatus();
      }
    } else {
      this.updateSubmitButtonStatus();
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    // const { selected_bank, nomor_rekening_bank, status_karyawan } = this.state;

    if (!this.state.agreement) {
      alert("❌ Anda harus menyetujui agreement!");
      return false;
    }

    // if (status_karyawan === "staff" || status_karyawan === "nonstaff") {
    //   if (selected_bank === "mandiri" || selected_bank === "mas") {
    //     const requiredDigits = selected_bank === "mandiri" ? 13 : 10;
    //     const bankName = selected_bank === "mandiri" ? "Mandiri" : "MAS";

    //     if (
    //       !nomor_rekening_bank ||
    //       nomor_rekening_bank.toString().length !== requiredDigits
    //     ) {
    //       alert(
    //         `❌ Nomor rekening ${bankName} harus tepat ${requiredDigits} digit!`
    //       );
    //       return false;
    //     }

    //     if (!/^\d+$/.test(nomor_rekening_bank)) {
    //       alert("❌ Nomor rekening hanya boleh berisi angka!");
    //       return false;
    //     }
    //   }

    //   if (this.state.foto_rekening_bank_status !== "Upload selesai") {
    //     alert("❌ Mohon upload foto rekening bank terlebih dahulu!");
    //     return false;
    //   }
    // }

    // ✅ VALIDASI: BPJS status specific
    if (this.state.bpjs_status === "active") {
      // if (
      //   !this.state.nomor_kartu_bpjs_kesehatan ||
      //   this.state.nomor_kartu_bpjs_kesehatan.trim() === ""
      // ) {
      //   alert("❌ Mohon isi nomor kartu BPJS kesehatan!");
      //   return false;
      // }

      if (
        !this.state.tanggal_pembuatan_surat_keterangan_sehat ||
        this.state.tanggal_pembuatan_surat_keterangan_sehat.trim() === ""
      ) {
        alert("❌ Mohon isi tanggal berlaku keterangan sehat!");
        return false;
      }

      if (this.state.foto_bpjs_kesehatan_status !== "Upload selesai") {
        alert("❌ Mohon upload foto BPJS kesehatan terlebih dahulu!");
        return false;
      }

      if (this.state.foto_keterangan_kesehatan_status !== "Upload selesai") {
        alert("❌ Mohon upload foto keterangan sehat terlebih dahulu!");
        return false;
      }
    }

    if (
      this.isBpjsKetenagakerjaanUploadRequired() &&
      this.state.foto_bpjs_ketenagakerjaan_status !== "Upload selesai"
    ) {
      alert("❌ Mohon upload foto BPJS ketenagakerjaan terlebih dahulu!");
      return false;
    }

    if (this.state.bpjs_status === "not_active") {
      if (
        this.state.foto_surat_pernyataan_kesanggupan_bpjs_status !==
        "Upload selesai"
      ) {
        alert(
          "❌ Mohon upload Surat Pernyataan Kesanggupan Menanggung Biaya BPJS terlebih dahulu!"
        );
        return false;
      }
      if (
        this.state.foto_keterangan_bpjs_tidak_aktif_status !== "Upload selesai"
      ) {
        alert(
          "❌ Mohon upload foto keterangan BPJS tidak aktif terlebih dahulu!"
        );
        return false;
      }
    }

    // ✅ VALIDASI: Gunakan validateRequiredFields untuk validasi lengkap
    if (!this.validateRequiredFields()) {
      alert("❌ Mohon lengkapi semua field yang wajib diisi!");
      return false;
    }

    // const status = "diisi";

    const {
      // ✅ TAMBAH: State yang hilang dari onSubmit
      // jenis_vaksin,
      // tanggal_vaksin_1,
      // lokasi_vaksin_1,
      // tanggal_vaksin_2,
      // lokasi_vaksin_2,
      // tanggal_vaksin_3,
      // lokasi_vaksin_3,

      // State upload URLs yang hilang
      ijasah_url,
      transkrip_url,
      skck_url,
      bpjs_kesehatan_url,
      bpjs_ketenagakerjaan_url,
      keterangan_kesehatan_url,
      peserta_jkn_url,
      iuran_jkn_url,
      surat_pernyataan_kesanggupan_bpjs_url,
      keterangan_bpjs_tidak_aktif_url,
      vaksinasi_1_url,
      vaksinasi_2_url,
      vaksinasi_3_url,
      pemadanan_npwp_url,
      surat_lamaran_url,
      formulir_lamaran_pekerjaan_url,
      formulir_okb_url,

      // State form data yang hilang
      tanggal_berlaku_skck,
      bpjs_status,
      tanggal_pembuatan_surat_keterangan_sehat,
      status_iuran,

      agreement,
    } = this.state;

    if (agreement !== true) {
      alert("Anda harus menyetujui agreement!");
      return false;
    }

    const form2Data = {
      // selected_bank,
      // nomor_rekening_bank,
      rekening_bank_url: this.state.rekening_bank_url,

      // jenis_vaksin,
      // tanggal_vaksin_1,
      // lokasi_vaksin_1,
      // tanggal_vaksin_2,
      // lokasi_vaksin_2,
      // tanggal_vaksin_3,
      // lokasi_vaksin_3,

      // Upload URLs
      ijasah_url,
      transkrip_url,
      skck_url,
      bpjs_kesehatan_url,
      bpjs_ketenagakerjaan_url,
      keterangan_kesehatan_url,
      peserta_jkn_url,
      iuran_jkn_url,
      surat_pernyataan_kesanggupan_bpjs_url,
      keterangan_bpjs_tidak_aktif_url,
      vaksinasi_1_url,
      vaksinasi_2_url,
      vaksinasi_3_url,
      pemadanan_npwp_url,
      surat_lamaran_url,
      formulir_lamaran_pekerjaan_url,
      formulir_okb_url,

      // Form data
      tanggal_berlaku_skck,
      bpjs_status,
      tanggal_pembuatan_surat_keterangan_sehat,
      status_iuran,
    };

    [
      "rekening_bank_url",
      "mutasi_rekening_url",
      "ijasah_url",
      "transkrip_url",
      "skck_url",
      "bpjs_kesehatan_url",
      "bpjs_ketenagakerjaan_url",
      "keterangan_kesehatan_url",
      "peserta_jkn_url",
      "iuran_jkn_url",
      "surat_pernyataan_kesanggupan_bpjs_url",
      "keterangan_bpjs_tidak_aktif_url",
      "vaksinasi_1_url",
      "vaksinasi_2_url",
      "vaksinasi_3_url",
      "pemadanan_npwp_url",
      "surat_lamaran_url",
      "formulir_lamaran_pekerjaan_url",
      "formulir_okb_url",
    ].forEach((urlField) => {
      const flagField = getValidateByOcrFieldName(urlField);
      if (flagField && this.state[flagField] === true) {
        form2Data[flagField] = true;
      }
    });

    // Mulai submit
    this.setState({
      submiting: true,
    });

    this.updateExistingEmployee(form2Data)
      .then((result) => {
        this.setState({ submiting: false });

        if (result.success) {
          // ✅ Update localStorage
          const currentData = JSON.parse(localStorage.getItem("id"));
          let isForm1Complete = false;
          if (currentData && currentData.length > 0) {
            currentData[0].form_2_submitted = "diisi";
            currentData[0].form_2_completed_date = new Date().toISOString();
            localStorage.setItem("id", JSON.stringify(currentData));
            isForm1Complete = currentData[0].form_1_submitted === "diisi";
          }

          if (isForm1Complete) {
            Swal.fire({
              title: "Selesai!",
              text: "Form 2 berhasil disubmit. Lanjut ke langkah berikutnya.",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Lanjut ke Form 3",
            }).then(() => {
              window.location.href = "/form-3";
            });
          } else {
            // 🚫 Jangan auto-redirect ke Form 3 jika Form 1 belum lengkap
            // Tujuan: mencegah munculnya validasi Form 1 (mis. hubungan kontak darurat) saat submit Form 2
            Swal.fire({
              title: "Form 2 tersimpan",
              text: "Form 2 berhasil disubmit. Silakan lengkapi Form 1 terlebih dahulu (termasuk Kontak Darurat) sebelum lanjut.",
              icon: "info",
              showCancelButton: true,
              confirmButtonText: "Ke Form 1",
              cancelButtonText: "Tutup",
            }).then((res) => {
              if (res.isConfirmed) {
                window.location.href = "/form";
              }
            });
          }
        } else {
          alert("❌ Gagal menyimpan Form 2: " + result.error);
        }
      })
      .catch((error) => {
        console.error("Error updating document: " + error);
        this.setState({ submiting: false });
        alert("Terjadi kesalahan saat menyimpan Form 2.");
      });
  };

  render() {
    // const {
    //   // alamatDisabled,
    //   // ASalamatDisabled,
    //   nomor_ktp,
    //   // nama_lengkap,
    //   // nomor_kk,
    //   nomor_npwp,
    // } = this.state;
    return (
      <div className="">
        <nav className="main-header-navbar navbar-expand-lg navbar navbar-with-menu bg-white">
          <div className="container-fluid">
            <div className="navbar-wrapper" style={{ width: "100%" }}>
              <div className="navbar-container">
                <div className="navbar-collapse" id="navbar-mobile">
                  <div className="mr-auto float-left bookmark-wrapper d-flex align-items-center logo-container">
                    <div className="navbar-header">
                      <ul className="nav navbar-nav flex-row">
                        <li className="nav-item mr-auto">
                          <a className="navbar-brand" href="/">
                            <div className="brand-logo">
                              <img
                                alt="Logo"
                                className="logo"
                                src={require("../assets/logos/logo-pas.jpg")}
                              />
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="mr-auto bookmark-wrapper d-flex align-items-center header-container">
                    <div className="navbar-header">
                      <ul className="nav navbar-nav flex-column">
                        <li className="nav-item text-center">
                          <h1 className="font-header">
                            PT. PRAKARSA ALAM SEGAR
                          </h1>
                        </li>
                        <li className="nav-item text-center">
                          <h2 className="font-sub-header">
                            Human Resource Department
                          </h2>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="bookmark-wrapper d-flex align-items-center">
                    <FormStepNav
                      current="form_2"
                      onGoForm1={this.goToForm1}
                      onGoForm2={this.goToForm2}
                      onGoForm3={this.goToForm3}
                      showForm3={this.canOpenForm3()}
                    />
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={this.handleLogout}
                      style={{ marginLeft: "10px" }}
                    >
                      <i className="bx bx-log-out"></i> Logout
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <div className="pembatas"></div>
        <section id="floating-label-layouts">
          <div className="container-fluid">
            <div className="row match-height">
              <div className="col-md-12 col-12">
                <div className="card bg-white">
                  <div className="card-header">
                    <h4 className="card-title text-center">
                      FORM DATA KARTU POKOK KARYAWAN
                    </h4>
                  </div>
                  <div className="card-content">
                    <div className="card-body">
                      <form
                        onSubmit={this.onSubmit}
                        onBlur={this.handleAutosaveBlur}
                        className="form"
                      >
                        <div className="form-body">
                          <div
                            className="alert bg-rgba-secondary alert-dismissible mb-2"
                            role="alert"
                          >
                            <div className="d-flex align-items-center">
                              <i className="bx bx-info-circle"></i>
                              <span>
                                {" "}
                                Setiap kolom dengan tanda (
                                <span className="text-danger">*</span>) wajib di
                                isi
                              </span>
                            </div>
                          </div>
                          <div className="row">
                            {/* ✅ TAMBAH: Section Rekening Bank (di atas Ijasah & Transkrip) */}
                            {(this.state.status_karyawan === "staff" ||
                              isNonstaffStatus(this.state.status_karyawan)) && (
                              <>
                                <div className="col-12 margin-top-5 mb-1">
                                  <h4>
                                    <u>Rekening Bank</u>
                                  </h4>
                                  <hr />
                                </div>
                                <div className="col-12">
                                  <div className="row justify-content-center">
                                    <div className="col-12 col-lg-6">
                                      <DocumentOcrUpload
                                        userOcrEnabled={this.state.trial}
                                        documentType="rekening"
                                        expectedName={this.state.nama_lengkap}
                                        expectedNik={this.state.nik}
                                        expectedBank={this.state.selected_bank}
                                        expectedAccount={
                                          this.state.nomor_rekening_bank
                                        }
                                        title={`Foto Rekening Bank ${
                                          this.state.selected_bank === "mandiri"
                                            ? "Mandiri"
                                            : this.state.selected_bank === "mas"
                                            ? "MAS"
                                            : "Mandiri / MAS"
                                        }`}
                                        placeholderSrc={
                                          this.state.selected_bank === "mas"
                                            ? require("../assets/images/rekening_mas.png")
                                            : require("../assets/images/rekening_mandiri.png")
                                        }
                                        previewUrl={this.state.rekeningBankUrl}
                                        fileLabel={
                                          this.state.foto_rekening_bank_label
                                        }
                                        uploadStatus={
                                          this.state.foto_rekening_bank_status
                                        }
                                        inputId="foto-rekening-bank"
                                        inputName="foto_rekening_bank"
                                        required={
                                          !(
                                            typeof this.state.rekening_bank_url ===
                                              "string" &&
                                            this.state.rekening_bank_url.trim() !==
                                              ""
                                          )
                                        }
                                        storageFolder={this.getStorageFolder()}
                                        validateImageFile={this.validateImageFile}
                                        onPreviewChange={this.handleOcrPreviewChange(
                                          "rekeningBankUrl",
                                          "rekeningBankFile"
                                        )}
                                        onStatusChange={(status) =>
                                          this.setState({
                                            foto_rekening_bank_status: status,
                                          })
                                        }
                                        onLabelChange={(label) =>
                                          this.setState({
                                            foto_rekening_bank_label: label,
                                          })
                                        }
                                        onUploadComplete={this.handleOcrUploadComplete(
                                          "rekening_bank_url",
                                          "foto_rekening_bank_status",
                                          "rekening_bank"
                                        )}
                                      />
                                    </div>
                                    <div className="col-12 col-lg-6">
                                      <DocumentOcrUpload
                                        userOcrEnabled={this.state.trial}
                                        documentType="mutasi"
                                        expectedName=""
                                        expectedBank={this.state.selected_bank}
                                        expectedAccount={
                                          this.state.nomor_rekening_bank
                                        }
                                        title={`Foto Mutasi Bank ${
                                          this.state.selected_bank === "mandiri"
                                            ? "Mandiri"
                                            : this.state.selected_bank === "mas"
                                            ? "MAS"
                                            : "Mandiri / MAS"
                                        }`}
                                        placeholderSrc={
                                          this.state.selected_bank === "mas"
                                            ? require("../assets/images/mutasi_mas.png")
                                            : require("../assets/images/mutasi_mandiri.png")
                                        }
                                        previewUrl={this.state.mutasiRekeningUrl}
                                        fileLabel={
                                          this.state.foto_mutasi_rekening_label
                                        }
                                        uploadStatus={
                                          this.state.foto_mutasi_rekening_status
                                        }
                                        inputId="foto-mutasi-rekening-bank"
                                        inputName="foto_mutasi_rekening"
                                        required={
                                          !(
                                            typeof this.state
                                              .mutasi_rekening_url ===
                                              "string" &&
                                            this.state.mutasi_rekening_url.trim() !==
                                              ""
                                          )
                                        }
                                        storageFolder={this.getStorageFolder()}
                                        validateImageFile={this.validateImageFile}
                                        onPreviewChange={this.handleOcrPreviewChange(
                                          "mutasiRekeningUrl",
                                          "mutasiRekeningFile"
                                        )}
                                        onStatusChange={(status) =>
                                          this.setState({
                                            foto_mutasi_rekening_status: status,
                                          })
                                        }
                                        onLabelChange={(label) =>
                                          this.setState({
                                            foto_mutasi_rekening_label: label,
                                          })
                                        }
                                        onUploadComplete={this.handleOcrUploadComplete(
                                          "mutasi_rekening_url",
                                          "foto_mutasi_rekening_status",
                                          "mutasi_rekening"
                                        )}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="col-12 margin-top-5 mb-1 mt-1">
                              <h4>
                                <u>Ijasah & Transkrip Nilai</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="row justify-content-center">
                                {this.renderPipelineUpload({
    documentType: "ijasah",
    title: "Foto Ijasah",
    placeholderSrc: require("../assets/images/ijasah.jpg"),
    previewKey: "ijasahUrl",
    fileKey: "ijasahFile",
    labelField: "foto_ijasah_label",
    statusField: "foto_ijasah_status",
    urlField: "ijasah_url",
    dbType: "ijasah",
    inputId: "foto-ijasah",
    inputName: "foto_ijasah",
    
  })}
                                {this.renderPipelineUpload({
    documentType: "transkrip",
    title: "Foto Transkrip Nilai",
    placeholderSrc: require("../assets/images/transkrip.jpg"),
    previewKey: "transkripUrl",
    fileKey: "transkripFile",
    labelField: "foto_transkrip_label",
    statusField: "foto_transkrip_status",
    urlField: "transkrip_url",
    dbType: "transkrip",
    inputId: "foto-transkrip",
    inputName: "foto_transkrip",
    
  })}
                              </div>
                            </div>
                            <div className="col-12 mt-2 mb-1">
                              <h4>
                                <u>SKCK</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="row justify-content-center">
                                <div className="col-12 col-lg-6">
                                  <DocumentOcrUpload
                                    userOcrEnabled={this.state.trial}
                                    documentType="skck"
                                    expectedName={this.state.nama_lengkap}
                                    expectedNik={this.state.nik}
                                    title="Foto SKCK"
                                    placeholderSrc={require("../assets/images/skck.jpg")}
                                    previewUrl={this.state.skckUrl}
                                    fileLabel={this.state.foto_skck_label}
                                    uploadStatus={this.state.foto_skck_status}
                                    inputId="foto-skck"
                                    inputName="foto_skck"
                                    required={
                                      !(
                                        typeof this.state.skck_url === "string" &&
                                        this.state.skck_url.trim() !== ""
                                      )
                                    }
                                    storageFolder={this.getStorageFolder()}
                                    validateImageFile={this.validateImageFile}
                                    onPreviewChange={this.handleOcrPreviewChange(
                                      "skckUrl",
                                      "skckFile"
                                    )}
                                    onStatusChange={(status) =>
                                      this.setState({ foto_skck_status: status })
                                    }
                                    onLabelChange={(label) =>
                                      this.setState({ foto_skck_label: label })
                                    }
                                    onUploadComplete={this.handleOcrUploadComplete(
                                      "skck_url",
                                      "foto_skck_status",
                                      "skck"
                                    )}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-12 col-xs-12">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  value={this.state.tanggal_berlaku_skck}
                                  onChange={this.onChange}
                                  required
                                  type="date"
                                  id="tanggal_berlaku_skck"
                                  className="form-control"
                                  name="tanggal_berlaku_skck"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-id-card"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="tanggal_berlaku_skck">
                                  Berlaku Hingga
                                </label>
                              </div>
                            </div>
                            <div className="col-12 margin-top-5 mb-1">
                              <h4>
                                <u>
                                  Kepesertaan dan Iuran BPJS Kesehatan (JKN
                                  Mobile)
                                </u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="row row-cols-2 d-flex">
                                {this.renderPipelineUpload({
    documentType: "jkn",
    title: "Foto Peserta BPJS Kesehatan (JKN Mobile)",
    placeholderSrc: require("../assets/images/peserta_jkn.png"),
    previewKey: "pesertaJKNUrl",
    fileKey: "pesertaJKNFile",
    labelField: "foto_peserta_jkn_label",
    statusField: "foto_peserta_jkn_status",
    urlField: "peserta_jkn_url",
    dbType: "peserta_jkn",
    inputId: "foto-peserta-jkn",
    inputName: "foto_peserta_jkn",
    
  })}
                                {this.renderPipelineUpload({
    documentType: "iuran",
    title: "Foto Iuran BPJS Kesehatan (JKN Mobile)",
    placeholderSrc: require("../assets/images/peserta_jkn.png"),
    previewKey: "iuranJKNUrl",
    fileKey: "iuranJKNFile",
    labelField: "foto_iuran_jkn_label",
    statusField: "foto_iuran_jkn_status",
    urlField: "iuran_jkn_url",
    dbType: "iuran_jkn",
    inputId: "foto-iuran-jkn",
    inputName: "foto_iuran_jkn",
    
  })}
                              </div>
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-group">
                                <label className="d-block">
                                  Status Iuran BPJS Kesehatan
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </label>
                                <div className="custom-control-inline">
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onChange}
                                      checked={this.state.status_iuran === "no"}
                                      value="no"
                                      type="radio"
                                      name="status_iuran"
                                      id="no_iuran"
                                    />
                                    <label htmlFor="no_iuran">Tidak ada</label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onChange}
                                      checked={
                                        this.state.status_iuran === "yes"
                                      }
                                      value="yes"
                                      type="radio"
                                      name="status_iuran"
                                      id="yes_iuran"
                                    />
                                    <label htmlFor="yes_iuran">Ada</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-12 margin-top-5">
                              <h4>
                                <u>BPJS Kesehatan Aktif / Tidak</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-sm-6 col-xs-12">
                              <div className="form-group">
                                <label className="d-block">
                                  Status BPJS Kesehatan{}
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </label>
                                <div className="custom-control-inline">
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onChange}
                                      checked={
                                        this.state.bpjs_status === "active"
                                      }
                                      required
                                      value="active"
                                      type="radio"
                                      name="bpjs_status" // ✅ PERBAIKAN
                                      id="bpjs_active"
                                    />
                                    <label htmlFor="bpjs_active">Aktif</label>
                                  </div>
                                  <div className="radio mr-1">
                                    <input
                                      onChange={this.onChange}
                                      checked={
                                        this.state.bpjs_status === "not_active"
                                      } // ✅ PERBAIKAN
                                      required
                                      value="not_active" // ✅ PERBAIKAN
                                      type="radio"
                                      name="bpjs_status" // ✅ PERBAIKAN
                                      id="bpjs_not_active"
                                    />
                                    <label htmlFor="bpjs_not_active">
                                      Tidak Aktif
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-12 margin-top-5 mb-1">
                              <h4>
                                <u>
                                  BPJS Kesehatan, Ketenagakerjaan & Surat
                                  Keterangan Sehat
                                </u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="row row-cols-2 d-flex">
                                {this.renderPipelineUpload({
                                  documentType: "bpjs",
                                  title: "Foto BPJS Kesehatan",
                                  placeholderSrc: require("../assets/images/bpjs_kesehatan.png"),
                                  previewKey: "bpjsKesehatanUrl",
                                  fileKey: "bpjsKesehatanFile",
                                  labelField: "foto_bpjs_kesehatan_label",
                                  statusField: "foto_bpjs_kesehatan_status",
                                  urlField: "bpjs_kesehatan_url",
                                  dbType: "bpjs_kesehatan",
                                  inputId: "foto-bpjs-kesehatan",
                                  inputName: "foto_bpjs_kesehatan",
                                  colClass: "col-12 col-lg-4",
                                })}
                                <div className="col-12 col-lg-4">
                                  {this.renderPipelineUpload({
                                    documentType: "bpjs_tk",
                                    title: this.isBpjsKetenagakerjaanUploadRequired()
                                      ? "Foto BPJS Ketenagakerjaan"
                                      : "Foto BPJS Ketenagakerjaan (opsional)",
                                    placeholderSrc: require("../assets/images/bpjs_ketenagakerjaan.png"),
                                    previewKey: "bpjsKetenagakerjaanUrl",
                                    fileKey: "bpjsKetenagakerjaanFile",
                                    labelField: "foto_bpjs_ketenagakerjaan_label",
                                    statusField: "foto_bpjs_ketenagakerjaan_status",
                                    urlField: "bpjs_ketenagakerjaan_url",
                                    dbType: "bpjs_ketenagakerjaan",
                                    inputId: "foto-bpjs-ketenagakerjaan",
                                    inputName: "foto_bpjs_ketenagakerjaan",
                                    optional: !this.isBpjsKetenagakerjaanUploadRequired(),
                                    colClass: "col-12",
                                  })}
                                  {!this.isBpjsKetenagakerjaanUploadRequired() && (
                                    <p className="small text-muted mt-1 mb-0">
                                      Tidak wajib diunggah karena pada Form 1
                                      keterangan kartu BPJS Ketenagakerjaan
                                      adalah Belum Dapat.
                                    </p>
                                  )}
                                </div>
                                <div className="col-12 col-lg-4">
                                  {this.renderPipelineUpload({
                                    documentType: "keterangan_kesehatan",
                                    title: "Foto Surat Keterangan Sehat",
                                    placeholderSrc: require("../assets/images/keterangan_sehat.jpg"),
                                    previewKey: "keteranganKesehatanUrl",
                                    fileKey: "keteranganKesehatanFile",
                                    labelField: "foto_keterangan_kesehatan_label",
                                    statusField: "foto_keterangan_kesehatan_status",
                                    urlField: "keterangan_kesehatan_url",
                                    dbType: "keterangan_kesehatan",
                                    inputId: "foto-keterangan-sehat",
                                    inputName: "foto_keterangan_kesehatan",
                                    colClass: "col-12",
                                  })}
                                </div>
                              </div>
                            </div>
                            {this.state.bpjs_status === "not_active" && (
                              <>
                                <div className="col-12 margin-top-5 mb-1">
                                  <h4>
                                    <u>Keterangan BPJS Tidak Aktif</u>
                                  </h4>
                                  <hr />
                                </div>
                                <div className="col-12">
                                  <div className="row justify-content-center">
                                    <div className="col-12 col-lg-6">
                                      {this.renderPipelineUpload({
                                        documentType: "bpjs_kesanggupan",
                                        title:
                                          "Foto Surat Pernyataan Kesanggupan Menanggung Biaya BPJS Kesehatan",
                                        placeholderSrc: require("../assets/images/surat_pernyataan_kesanggupan_bpjs.jpg"),
                                        previewKey: "suratPernyataanKesanggupanBPJSUrl",
                                        fileKey: "suratPernyataanKesanggupanBPJSFile",
                                        labelField:
                                          "foto_surat_pernyataan_kesanggupan_bpjs_label",
                                        statusField:
                                          "foto_surat_pernyataan_kesanggupan_bpjs_status",
                                        urlField:
                                          "surat_pernyataan_kesanggupan_bpjs_url",
                                        dbType: "surat_pernyataan_kesanggupan_bpjs",
                                        inputId:
                                          "foto-surat-pernyataan-kesanggupan-bpjs",
                                        inputName:
                                          "foto_surat_pernyataan_kesanggupan_bpjs",
                                        colClass: "col-12",
                                      })}
                                    </div>
                                    <div className="col-12 col-lg-6">
                                      <div className="card bg-secondary bg-lighten-1">
                                        <div className="card-content text-white">
                                          <div className="card-body pt-10">
                                            <div className="text-center">
                                              <img
                                                src={
                                                  this.state
                                                    .bpjsTidakAktifUrl == null
                                                    ? require("../assets/images/keterangan_bpjs_tidak_aktif.jpg")
                                                    : this.state
                                                        .bpjsTidakAktifUrl
                                                }
                                                alt="Foto KK"
                                                className="mb-1 w-50 mt-1"
                                              />
                                              <h4 className="card-title white mt-2">
                                                Foto Keterangan BPJS Tidak Aktif
                                              </h4>
                                            </div>
                                            <div className="card-text">
                                              <div className="custom-file">
                                                <input
                                                  accept="image/x-png,image/jpeg"
                                                  required={
                                                    !(
                                                      typeof this.state
                                                        .keterangan_bpjs_tidak_aktif_url ===
                                                        "string" &&
                                                      this.state.keterangan_bpjs_tidak_aktif_url.trim() !==
                                                        ""
                                                    )
                                                  }
                                                  name="bpjs_tidak_aktif"
                                                  onChange={
                                                    this
                                                      .selectFotoKeteranganBPJSTidakAktif
                                                  }
                                                  type="file"
                                                  className="custom-file-input"
                                                  id="foto-bpjs-tidak-aktif"
                                                />
                                                <i className="text-danger">
                                                  Maksimal ukuran file 3 MB,
                                                  Tipe gambar PNG / JPG
                                                </i>
                                                <p>
                                                  <i>
                                                    {
                                                      this.state
                                                        .foto_keterangan_bpjs_tidak_aktif_status
                                                    }
                                                  </i>
                                                </p>
                                                <label
                                                  className="custom-file-label"
                                                  htmlFor="foto-bpjs-tidak-aktif"
                                                >
                                                  {this.state
                                                    .foto_keterangan_bpjs_tidak_aktif_label ==
                                                  null ? (
                                                    <span>Pilih File</span>
                                                  ) : (
                                                    this.state
                                                      .foto_keterangan_bpjs_tidak_aktif_label
                                                  )}
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="col-sm-12 col-xs-12 mt-2">
                              <div className="form-label-group position-relative has-icon-left">
                                <input
                                  value={
                                    this.state
                                      .tanggal_pembuatan_surat_keterangan_sehat
                                  }
                                  onChange={this.onChange}
                                  required
                                  type="date"
                                  id="tanggal_pembuatan_surat_keterangan_sehat"
                                  className="form-control"
                                  name="tanggal_pembuatan_surat_keterangan_sehat"
                                />
                                <div className="form-control-position">
                                  <i className="bx bx-id-card"></i>
                                  <span className="text-danger wajib-diisi">
                                    *
                                  </span>
                                </div>
                                <label htmlFor="tanggal_pembuatan_surat_keterangan_sehat">
                                  Tanggal Pembuatan Surat Keterangan Sehat
                                </label>
                              </div>
                            </div>
                            <div className="col-12 mt-2 mb-1">
                              <h4>
                                <u>Upload Sertifikat Vaksinasi Covid-19</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="row justify-content-center">
                                {this.renderPipelineUpload({
    documentType: "vaksinasi_1",
    title: "Foto Sertifikat Vaksinasi 1",
    placeholderSrc: require("../assets/images/vaksinasi.jpg"),
    previewKey: "vaksinasi1Url",
    fileKey: "vaksinasi1File",
    labelField: "foto_vaksinasi_1_label",
    statusField: "foto_vaksinasi_1_status",
    urlField: "vaksinasi_1_url",
    dbType: "vaksinasi_1",
    inputId: "foto-vaksinasi-1",
    inputName: "foto_vaksinasi_1",
    
  })}
                                {this.renderPipelineUpload({
    documentType: "vaksinasi_2",
    title: "Foto Sertifikat Vaksinasi 2 (opsional)",
    placeholderSrc: require("../assets/images/vaksinasi.jpg"),
    previewKey: "vaksinasi2Url",
    fileKey: "vaksinasi2File",
    labelField: "foto_vaksinasi_2_label",
    statusField: "foto_vaksinasi_2_status",
    urlField: "vaksinasi_2_url",
    dbType: "vaksinasi_2",
    inputId: "foto-vaksinasi-2",
    inputName: "foto_vaksinasi_2",
    optional: true,
  })}
                                {this.renderPipelineUpload({
    documentType: "vaksinasi_3",
    title: "Foto Sertifikat Vaksinasi 3 (opsional)",
    placeholderSrc: require("../assets/images/vaksinasi.jpg"),
    previewKey: "vaksinasi3Url",
    fileKey: "vaksinasi3File",
    labelField: "foto_vaksinasi_3_label",
    statusField: "foto_vaksinasi_3_status",
    urlField: "vaksinasi_3_url",
    dbType: "vaksinasi_3",
    inputId: "foto-vaksinasi-3",
    inputName: "foto_vaksinasi_3",
    optional: true,
  })}
                              </div>
                            </div>
                            <div className="col-12 margin-top-5 mb-1 mt-1">
                              <h4>
                                <u>Upload Pemadanan NPWP</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="row justify-content-center">
                                {this.renderPipelineUpload({
    documentType: "pemadanan_npwp",
    title: "Foto Pemadanan NPWP",
    placeholderSrc: require("../assets/images/pemadanan_npwp.png"),
    previewKey: "pemadananNPWPUrl",
    fileKey: "pemadananNPWPFile",
    labelField: "foto_pemadanan_npwp_label",
    statusField: "foto_pemadanan_npwp_status",
    urlField: "pemadanan_npwp_url",
    dbType: "pemadanan_npwp",
    inputId: "foto-pemadanan-npwp",
    inputName: "foto_pemadanan_npwp",
    
  })}
                              </div>
                            </div>
                            <div className="col-12 margin-top-5 mb-1 mt-1">
                              <h4>
                                <u>Upload Surat Lamaran Kerja</u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="row justify-content-center">
                                {this.renderPipelineUpload({
    documentType: "surat_lamaran",
    title: "Foto Surat Lamaran Kerja",
    placeholderSrc: require("../assets/images/surat_lamaran.jpg"),
    previewKey: "suratLamaranUrl",
    fileKey: "suratLamaranFile",
    labelField: "foto_surat_lamaran_label",
    statusField: "foto_surat_lamaran_status",
    urlField: "surat_lamaran_url",
    dbType: "surat_lamaran",
    inputId: "foto-surat-lamaran",
    inputName: "foto_surat_lamaran",
    
  })}
                              </div>
                            </div>
                            <div className="col-12 margin-top-5 mb-1 mt-1">
                              <h4>
                                <u>
                                  Upload Formulir Lamaran Pekerjaan & Orientasi
                                  Karyawan Baru
                                </u>
                              </h4>
                              <hr />
                            </div>
                            <div className="col-12">
                              <div className="row row-cols-2 d-flex">
                                {this.renderPipelineUpload({
                                  documentType: "formulir_lamaran",
                                  title:
                                    "Formulir Lamaran Pekerjaan (4 halaman Dalam 1 PDF, Maks 3 MB)",
                                  placeholderSrc: require("../assets/images/form_lamaran.jpg"),
                                  previewKey: "formulirLamaranPekerjaanUrl",
                                  fileKey: "formulirLamaranPekerjaanFile",
                                  labelField:
                                    "foto_formulir_lamaran_pekerjaan_label",
                                  statusField:
                                    "foto_formulir_lamaran_pekerjaan_status",
                                  urlField: "formulir_lamaran_pekerjaan_url",
                                  dbType: "formulir_lamaran_pekerjaan",
                                  inputId: "foto-formulir-lamaran-pekerjaan",
                                  inputName: "foto_formulir_lamaran_pekerjaan",
                                  accept: "application/pdf",
                                  fileTypeHint: "file PDF",
                                  previewMode: "pdf",
                                  validateFile: this.validatePdfFile,
                                })}
                                {this.renderPipelineUpload({
    documentType: "formulir_okb",
    title: "Formulir Orientasi Karyawan Baru (OKB)",
    placeholderSrc: require("../assets/images/form_checklist_okb.jpg"),
    previewKey: "formulirOKBUrl",
    fileKey: "formulirOKBFile",
    labelField: "foto_formulir_okb_label",
    statusField: "foto_formulir_okb_status",
    urlField: "formulir_okb_url",
    dbType: "formulir_okb",
    inputId: "foto-formulir-okb",
    inputName: "foto_formulir_okb",
    
  })}
                              </div>
                            </div>
                            <div className="col-12 mt-1">
                              {!this.state.isFormValid && (
                                <div
                                  className="card border-danger shadow-sm mb-3"
                                  style={{
                                    maxWidth: 600,
                                    margin: "0 auto",
                                    background: "#fff6f6",
                                  }}
                                >
                                  <div className="card-body py-2 px-3">
                                    <div className="d-flex align-items-center mb-2">
                                      <i
                                        className="bx bx-error-circle text-danger"
                                        style={{
                                          fontSize: 24,
                                          marginRight: 8,
                                        }}
                                      ></i>
                                      <h6
                                        className="text-danger mb-0"
                                        style={{ fontWeight: 700 }}
                                      >
                                        Kolom wajib & dokumen yang belum
                                        diisi/upload:
                                      </h6>
                                    </div>

                                    {/* ✅ Tampilkan field yang belum diisi */}
                                    <div>
                                      <div
                                        className="mb-1"
                                        style={{ fontWeight: 600 }}
                                      >
                                        Kolom Wajib:
                                      </div>
                                      <ul
                                        className="mb-2 pl-3"
                                        style={{ fontSize: "0.9em" }}
                                      >
                                        {!this.state.tanggal_berlaku_skck && (
                                          <li className="text-danger">
                                            Tanggal Berlaku SKCK
                                          </li>
                                        )}
                                        {!this.state.bpjs_status && (
                                          <li className="text-danger">
                                            Status BPJS
                                          </li>
                                        )}
                                        {!this.state.status_iuran && (
                                          <li className="text-danger">
                                            Status Iuran JKN
                                          </li>
                                        )}
                                        {!this.state
                                          .tanggal_pembuatan_surat_keterangan_sehat && (
                                          <li className="text-danger">
                                            Tanggal Berlaku Keterangan Sehat
                                          </li>
                                        )}
                                        {!this.state.agreement && (
                                          <li className="text-danger">
                                            Persetujuan (Checklist)
                                          </li>
                                        )}
                                      </ul>
                                    </div>

                                    {/* ✅ Tampilkan dokumen yang belum diupload */}
                                    <div>
                                      <div
                                        className="mb-1"
                                        style={{ fontWeight: 600 }}
                                      >
                                        Dokumen/Foto Wajib:
                                      </div>
                                      <ul
                                        className="mb-0 pl-3"
                                        style={{ fontSize: "0.9em" }}
                                      >
                                        {/* Rekening Bank (jika staff/nonstaff) */}
                                        {(this.state.status_karyawan ===
                                          "staff" ||
                                          isNonstaffStatus(
                                            this.state.status_karyawan,
                                          )) && (
                                          <>
                                            {this.state
                                              .foto_rekening_bank_status !==
                                              "Upload selesai" && (
                                              <li className="text-danger">
                                                Foto Rekening Bank
                                              </li>
                                            )}
                                            {this.state
                                              .foto_mutasi_rekening_status !==
                                              "Upload selesai" && (
                                              <li className="text-danger">
                                                Foto Mutasi Rekening Bank
                                              </li>
                                            )}
                                          </>
                                        )}

                                        {/* Ijasah & Transkrip */}
                                        {this.state.foto_ijasah_status !==
                                          "Upload selesai" && (
                                          <li className="text-danger">
                                            Foto Ijasah
                                          </li>
                                        )}
                                        {this.state.foto_transkrip_status !==
                                          "Upload selesai" && (
                                          <li className="text-danger">
                                            Foto Transkrip
                                          </li>
                                        )}

                                        {/* SKCK */}
                                        {this.state.foto_skck_status !==
                                          "Upload selesai" && (
                                          <li className="text-danger">
                                            Foto SKCK
                                          </li>
                                        )}

                                        {/* JKN */}
                                        {this.state.foto_peserta_jkn_status !==
                                          "Upload selesai" && (
                                          <li className="text-danger">
                                            Foto Peserta JKN
                                          </li>
                                        )}
                                        {this.state.foto_iuran_jkn_status !==
                                          "Upload selesai" && (
                                          <li className="text-danger">
                                            Foto Iuran JKN
                                          </li>
                                        )}

                                        {this.isBpjsKetenagakerjaanUploadRequired() &&
                                          this.state
                                            .foto_bpjs_ketenagakerjaan_status !==
                                            "Upload selesai" && (
                                            <li className="text-danger">
                                              Foto BPJS Ketenagakerjaan
                                            </li>
                                          )}

                                        {/* BPJS Kesehatan & Keterangan Sehat (selalu wajib) */}
                                        {this.state
                                          .foto_bpjs_kesehatan_status !==
                                          "Upload selesai" && (
                                          <li className="text-danger">
                                            Foto BPJS Kesehatan
                                          </li>
                                        )}
                                        {this.state
                                          .foto_keterangan_kesehatan_status !==
                                          "Upload selesai" && (
                                          <li className="text-danger">
                                            Foto Surat Keterangan Sehat
                                          </li>
                                        )}

                                        {/* BPJS Tidak Aktif (conditional) */}
                                        {this.state.bpjs_status ===
                                          "not_active" && (
                                          <>
                                            {this.state
                                              .foto_surat_pernyataan_kesanggupan_bpjs_status !==
                                              "Upload selesai" && (
                                              <li className="text-danger">
                                                Surat Pernyataan Kesanggupan
                                                BPJS
                                              </li>
                                            )}
                                            {this.state
                                              .foto_keterangan_bpjs_tidak_aktif_status !==
                                              "Upload selesai" && (
                                              <li className="text-danger">
                                                Keterangan BPJS Tidak Aktif
                                              </li>
                                            )}
                                          </>
                                        )}

                                        {/* Vaksinasi */}
                                        {this.state.foto_vaksinasi_1_status !==
                                          "Upload selesai" && (
                                          <li className="text-danger">
                                            Foto Sertifikat Vaksinasi 1
                                          </li>
                                        )}

                                        {/* NPWP & Lamaran */}
                                        {this.state
                                          .foto_pemadanan_npwp_status !==
                                          "Upload selesai" && (
                                          <li className="text-danger">
                                            Foto Pemadanan NPWP
                                          </li>
                                        )}
                                        {this.state
                                          .foto_surat_lamaran_status !==
                                          "Upload selesai" && (
                                          <li className="text-danger">
                                            Foto Surat Lamaran
                                          </li>
                                        )}
                                        {this.state
                                          .foto_formulir_lamaran_pekerjaan_status !==
                                          "Upload selesai" && (
                                          <li className="text-danger">
                                            Formulir Lamaran Pekerjaan (PDF)
                                          </li>
                                        )}
                                        {this.state.foto_formulir_okb_status !==
                                          "Upload selesai" && (
                                          <li className="text-danger">
                                            Formulir OKB
                                          </li>
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              )}
                              <div
                                className="alert border-secondary mb-2"
                                role="alert"
                                style={{
                                  background: "rgb(220 223 255)",
                                }}
                              >
                                <div className="d-flex align-items-center">
                                  <div>
                                    <label
                                      htmlFor="agreement"
                                      style={{
                                        textTransform: "capitalize !important",
                                        fontWeight: 800,
                                      }}
                                    >
                                      Demikian Form Data Karyawan ini saya isi
                                      dengan sebenarnya tanpa adanya paksaan
                                      dari pihak lain manapun, sebagai syarat
                                      bekerja di PT.Prakarsa Alam Segar. Apabila
                                      dikemudian hari ditemukan bahwa pernyataan
                                      yang saya buat di atas adalah tidak benar,
                                      maka hal ini dapat dijadikan dasar bagi
                                      Perusahaan untuk melakukan pemutusan
                                      hubungan kerja dan Saya tidak memiliki hak
                                      apapun terkait pemutusan hubungan kerja
                                      tersebut.
                                    </label>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    position: "relative",
                                  }}
                                >
                                  <button
                                    type="button"
                                    onClick={this.agreementChange}
                                    aria-pressed={this.state.agreement}
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      padding: "10px 16px",
                                      fontSize: "1rem",
                                      fontWeight: 600,
                                      borderRadius: 6,
                                      border: "none", // no border
                                      cursor: "pointer",
                                      userSelect: "none",
                                      transition: "transform .05s ease-in-out",
                                      color: this.state.agreement
                                        ? "#FFFFFF"
                                        : "#475F7B",
                                      backgroundColor: this.state.agreement
                                        ? "#28a745"
                                        : "#E7EDF3",
                                      boxShadow: "none", // no shadow
                                    }}
                                    onMouseDown={(e) =>
                                      (e.currentTarget.style.transform =
                                        "scale(0.98)")
                                    }
                                    onMouseUp={(e) =>
                                      (e.currentTarget.style.transform =
                                        "scale(1)")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.currentTarget.style.transform =
                                        "scale(1)")
                                    }
                                  >
                                    <i
                                      className={`bx ${
                                        this.state.agreement
                                          ? "bx-check-circle"
                                          : "bx-circle"
                                      }`}
                                      style={{
                                        fontSize: "1.2rem",
                                        marginRight: 4,
                                      }} // tighter spacing
                                    />
                                    {this.state.agreement
                                      ? "Sudah Disetujui"
                                      : "Setujui"}
                                  </button>

                                  <input
                                    checked={this.state.agreement}
                                    name="agreement"
                                    type="checkbox"
                                    id="agreement"
                                    readOnly
                                    style={{
                                      position: "absolute",
                                      opacity: 0,
                                      pointerEvents: "none",
                                      width: 0,
                                      height: 0,
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              <hr />
                            </div>
                            <div className="col-12 d-flex justify-content-center">
                              <button
                                type="submit"
                                className={`btn mb-1 ${
                                  this.state.isFormValid &&
                                  !this.state.submiting
                                    ? "btn-primary"
                                    : "btn-secondary"
                                }`}
                              >
                                {this.state.submiting === true ? (
                                  <span>Submiting.. </span>
                                ) : (
                                  <span>
                                    {this.state.isFormValid
                                      ? "Submit"
                                      : "Lengkapi Form"}
                                  </span>
                                )}
                              </button>
                            </div>

                            {!this.state.isFormValid && (
                              <div className="w-100">
                                <small className="text-muted d-block text-center">
                                  <i className="bx bx-info-circle"></i>
                                  Pastikan semua field wajib (*) telah diisi dan
                                  file telah diupload
                                </small>
                              </div>
                            )}
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Form2;
